<template v-if="notEmpty(odata)">
    <bookingHeader :step="step" :steplist="orderStore.bookingSteps" :Authorization="authorization"
        @customerRefresh="customerRefresh" @refreshStep="refreshStep"></bookingHeader>
    <div class="page wp" id="paymentPage" style="height: calc(100vh - 15rem) !important;">
        <div class="flexpage" v-if="odkey != ''">
            <div class="leftpage" id="leftpage">
                <div class="pressPayment" v-if="pressnum == 3">

                    <div class="modelbox" v-if="agentcomm_status && customerInfo.has_company">
                        <!--<div class="title">Do you have a Coupon Code?</div>-->
                        <div class="titlebox">
                            <div class="title">How would you like to pay?</div>
                        </div>
                        <div class="formbox ">
                            <template v-for="(item, idx) in ['Traveler\'s credit card', 'Agent credit card']">
                                <div class="row radiobox" @click="changeAgentPayemt(idx)"
                                    :class="(idx == netprice ? 'on' : '')">
                                    <div class="info">
                                        <p class="txt">{{ item }}</p>
                                    </div>
                                    <el-radio v-model="netprice" label="" :value="idx"></el-radio>
                                </div>
                            </template>
                        </div>
                    </div>
                    <template v-else>
                        <div class="modelbox">
                            <div class="formbox" v-if="odata?.groupon_order_id??false">
                                <div class="wholerow" style="font-size:1.6rem;font-weight:700;margin-bottom:0.8rem;">
                                    Groupon Voucher Security Code<i style="color:#F92D2D;font-style:normal;margin-left:0.3rem;">*</i>
                                </div>
                                <div class="wholerow" style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:0.4rem;margin-bottom:1.6rem;">
                                    <span style="font-size:1.3rem;color:#666;font-weight:400;">Please purchase your Groupon voucher before booking</span>
                                    <a href="https://www.groupon.com" target="_blank" style="font-size:1.3rem;color:#00C49A;font-weight:500;text-decoration:none;white-space:nowrap;">
                                        Purchase more voucher codes on Groupon &nbsp;&#8594;
                                    </a>
                                </div>
                                <div class="groupon-voucher-layout " v-if="odata?.groupon_codes?.length>0" >
                                    <div class="groupon-voucher-main">
                                        <template v-for="(code, idx) in odata.groupon_codes" :key="idx">
                                            <div class="row">
                                                <div class="label">Traveler {{ idx + 1 }}</div>
                                                <input type="text" class="input" :value="code.voucher_code" placeholder="Enter voucher code" />
                                            </div>
                                        </template>
                                        
                                        <div class="wholerow" v-if="couponErr != ''" style="margin-bottom: 8px;">
                                            <div class="rowdiv err">{{ couponErr }}</div>
                                        </div>
                                        <div class="wholerow groupon-applied-row" v-if="appliedGrouponCodes?.length>0">
                                            <div class="capplied groupon-applied">
                                                <div class="rowdiv msg groupon-applied__content">
                                                <span class="groupon-applied__title">Applied Groupon codes:</span>
                                                <div class="groupon-applied__chips">
                                                    <span
                                                        v-for="(item,cidx) in appliedGrouponCodes"
                                                        :key="cidx"
                                                        class="groupon-applied__chip"
                                                    >
                                                        <span class="groupon-applied__chip-text">{{ item }}</span>
                                                        <button
                                                            type="button"
                                                            class="groupon-applied__chip-remove"
                                                            @click="removeGrouponVoucherCode(item)"
                                                        >
                                                            ×
                                                        </button>
                                                    </span>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="button" :class="'btn rdiv vchbtn '" style="margin-top: 40px;" :disabled="couponApplying" :aria-busy="couponApplying" @click="applyCoupon(2)">{{ couponApplying ? 'Applying…' : 'Apply' }}</button>
                                </div>
                            </div>
                            <div class="formbox" v-else>
                                <div class="wholerow">Voucher Code</div>
                                <div class="wholerow childcenter">
                                    <div class="ldiv" style="display: flex; flex-grow: 1; margin-right: 10px;">
                                        <div class="codebox" style="width: 100%;">
                                            <input type="text" :placeholder="couponPlaceHolder" class="input"
                                                v-model="voucher" @focus="onVoucherFocus" />
                                        </div>
                                    </div>
                                    <div :class="'btn rdiv vchbtn ' + (voucher != '' ? '' : 'inabtn')"
                                        @click="applyCoupon(1)">
                                        Apply
                                    </div>
                                </div>
                                <div class="wholerow" v-if="couponErr != ''" style="margin-bottom: 8px;">
                                    <div class="rowdiv err">{{
                                        couponErr }}</div>
                                </div>
                                <div class="wholerow capplied" v-else-if="discounts.coupon != ''">
                                    <div class="rowdiv msg"> Applied:
                                        <span style="font-weight:bolder;">{{ discounts.coupon }}</span>
                                        <img src="/images/icon_close.png" class="vchimg" @click="applyCoupon(1)">
                                    </div>
                                </div>
                            </div>
                            <div class="formbox" v-if="notEmpty(credits)">
                                <div class="wholerow">Welcome Points & Referral Points</div>
                                <div class="wholerow childcenter">
                                    <template v-if="Object.keys(credits).length > 1">
                                        <div class="ldiv">
                                            <div>
                                                <template v-for="(item, idx) in credits">
                                                    <el-checkbox-group v-model="discounts.credit">
                                                        <div class="checkbox-row">
                                                            <el-checkbox :value="item.ctid"
                                                                :label="item.name + ': ' + (item.display || rd(item.amount, 2))"></el-checkbox>
                                                        </div>
                                                    </el-checkbox-group>
                                                </template>
                                            </div>
                                        </div>
                                        <div :class="'btn rdiv vchbtn'" @click="applyCoupon(0)">
                                            Apply
                                        </div>
                                    </template>
                                    <template v-else v-for="(item, idx) in credits">
                                        <el-checkbox-group v-model="discounts.credit" @change="applyCoupon(0)">
                                            <div class="checkbox-row">
                                                <el-checkbox :value="item.ctid"
                                                    :label="item.name + ': ' + (item.display || rd(item.amount, 2))"></el-checkbox>
                                            </div>
                                        </el-checkbox-group>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div id="pdfExport">
                        <div class="modelbox">
                            <template v-if="payment_types.length > 0">
                                <div class="titlebox">
                                    <div class="title">Payment Amount</div>
                                </div>
                                <div class="formbox ">
                                    <template v-for="(item, idx) in payment_types">
                                        <div class="row radiobox" v-if="item.title != 'Payment Credit'"
                                            @click="changePaymentType(item)"
                                            :class="(payment_type == getLowerCase(item.title) ? 'on' : '')">
                                            <div class="info">
                                                <template v-if="insuranceStore.unPay>0 && insuranceStore.unPay!=insuranceStore.unPayDisplay">
                                                    <p class="price" >{{ pagePriceFormat({currency:currencyStore.currentCurrency,amount:(parseFloat(item.amount)-parseFloat(item.common_amount?.insurance??0))},{currency:'USD',amount:insuranceStore.unPay??0},',') }}</p>
                                                    <p class="price" >({{ item.format }})</p>
                                                </template>                                                
                                                <p class="price" v-else>{{ item.format }}</p>
                                                <p class="txt">{{ item.title }}</p>
                                            </div>
                                            <el-radio v-model="radioValue" label=""
                                                :value="getLowerCase(item.title)"></el-radio>
                                        </div>
                                    </template>
                                </div>
                            </template>

                            <div class="titlebox">
                                <div class="title">Payment Method</div>
                                <div class="paytype">
                                    <img src="/images/flight/type1.png" class="ico">
                                    <img src="/images/flight/type2.png" class="ico">
                                    <img src="/images/flight/type3.png" class="ico">
                                    <img src="/images/flight/paypal.png" class="ico">
                                    <!--        <img src="/images/flight/type4.png" class="ico"> -->
                                    <span class="paytype-label">TTG Coins</span>
                                </div>
                            </div>
                            <div class="formbox">
                                <div class="rowdiv ttg-coins-panel" v-if="canUseSplitCredit()">
                                    <div class="ttg-coins-title">Apply TTG Coins</div>
                                    <div class="ttg-coins-field">
                                        <el-input-number class="ttg-coins-input" v-model="payment_credit.amount"
                                            :precision="2" :controls="false" :min="0" :max="maxCoinValue"  @change="checkCreditAmt">
                                        </el-input-number>
                                        <div class="ttg-coins-balance">
                                            TTG Coins Balance:
                                            <span>{{ rewardsPointBalance }}</span>
                                        </div>
                                    </div>
                                    <div class="ttg-coins-description">
                                        <span class="ttg-coins-info-icon">i</span>
                                        <span>
                                            You can apply your TTG Coins to your reservation. The outstanding amount will
                                            be processed via other payment method.
                                        </span>
                                    </div>
                                    <div class="ttg-coins-divider"></div>
                                    <div class="ttg-coins-remaining">
                                        Remaining amount:
                                        <span>{{ remainingAmountFormatted }}</span>
                                    </div>
                                </div>
                                <!-- </div>
                        <div class="formbox">  -->

                                <div class="row width Creditbox">
                                    <img src="/images/flight/Credit.png" class="iconpic">
                                    <el-select v-model="payment_method" placeholder="Credit or debit card"
                                        class="input required" data-parent="1" data-model="payment_method"
                                        @change="initStripeIfNeeded">
                                        <template v-for="(item, idx) in payment_methods">
                                            <el-option v-if="validPaymentMethod(item)" :key="item.code"
                                                :label="item.title" :value="item.code"></el-option>
                                        </template>
                                    </el-select>
                                </div>

                                <!-- PayPal Pay Later flex banner — rendered by PaypalButton.vue into this container -->
                                <div v-if="payment_method === 'paypal_checkout'"
                                     id="paypal-paylater-flex-banner"
                                     class="paypal-flex-banner-wrap">
                                </div>

                                <!------------------Stripe card elements (3D/SCA) --------------------------------->
                                <template v-if="payment_method === 'stripe'">
                                    <div class="row">
                                        <p class="label">Card Number <i>*</i></p>
                                        <div id="card-number" class="stripe-input"></div>
                                    </div>
                                    <div class="row">
                                        <p class="label">Expiration Date <i>*</i></p>
                                        <div id="card-expiry" class="stripe-input"></div>
                                    </div>
                                    <div class="row">
                                        <p class="label">CVC <i>*</i></p>
                                        <div id="card-cvc" class="stripe-input"></div>
                                    </div>
                                </template>
                                <!------------------Visa/Master---------1.landonly flight with signature 2.Amout>credit 3.eselect_plus payment method----------------->
                                <template v-else-if="shouldShowCardPaymentFields()">
                                    <div class="row">
                                        <p class="label">Name On Card <i>*</i></p>
                                        <input type="text" placeholder="Name On Card" class="input required"
                                            data-parent="1" data-model="payinfo.name" v-model="payinfo.name" />
                                    </div>
                                    <div class="row">
                                        <p class="label">Card Type <i>*</i></p>
                                        <el-select v-model="payinfo.type" placeholder="Card Type"
                                            class="customer-select input required" data-parent="1"
                                            data-model="payinfo.type">
                                            <template v-for="pitem in payment_methods">
                                                <template
                                                    v-if="((pitem.code == 'eselectplus_api' || pitem.code == 'pp_pro') && (payment_method == '' || payment_method == pitem.code)) || (pitem.code == 'free_checkout' && isSignature > 0 && payment_method == pitem.code)">
                                                    <el-option v-for="(item, index) in pitem.type" :key="index"
                                                        :label="item.title" :value="item.code">
                                                        <span>{{ item.title }}</span>
                                                    </el-option>
                                                </template>
                                            </template>
                                        </el-select>
                                    </div>
                                    <div class="row width " id="number">
                                        <p class="label">Card Number <i>*</i></p>
                                        <input type="text" placeholder="Card Number" @input="numberKeypress"
                                            class="input required" data-parent="1" v-model="payinfo.number"
                                            data-model="payinfo.number" />
                                    </div>
                                    <div class="row " id='expiredate'>
                                        <p class="label">Expiration Date <i>*</i></p>
                                        <div class="input required" data-parent="1" data-model="payinfo.date">
                                            <el-date-picker ref="monthPicker" v-model="payinfo.date" type="month"
                                                format="YYYY/MM" value-format="YYYY-MM" placeholder="YYYY-MM"
                                                :disabled-date="disabledDate" :picker-options="datePickerOptions"
                                                class="input" />
                                        </div>
                                    </div>
                                    <div class="row" id="cvccvv">
                                        <p class="label">CVC/CVV2 <i>*</i> <img src="/images/flight/icon_info.png"
                                                class="ico"></p>
                                        <input type="text" placeholder="CVC/CVV2" class="input required" data-parent="1"
                                            data-model="payinfo.cvccvv" v-model="payinfo.cvccvv" @input="cvcKeypress" />
                                    </div>

                                </template>
                                <!--------------cheque : common for agent----------------------------------------->
                                <template v-if="payment_method == 'cheque' && isSignature==0">
                                    <div class="row">
                                        <p class="label">Payable</p>
                                        <el-input v-model="payinfo.payable" placeholder="Payable" class="required"
                                            data-parent="1" data-model="payinfo.payable"></el-input>
                                    </div>
                                    <div class="row">
                                        <p class="label">Mailing address</p>
                                        <el-input v-model="payinfo.address" placeholder="Mailing address"
                                            class="required" data-parent="1" data-model="payinfo.address"></el-input>
                                    </div>
                                    <p class="notes">
                                        Please note your oder is on hold until we receive your payment
                                        (cheque/money order).
                                    </p>
                                </template>
                                <!--------------Payment_Transfer payment method----------credit > payment amount------------------------------->
                                <template
                                    v-if="payment_method == 'Payment_Transfer' && paypalAmount <= 0 && isSignature == 0">
                                    <div class="row">
                                        <p class="label">Important note</p>
                                        <el-input v-model="payinfo.note" placeholder="Important note"></el-input>
                                    </div>
                                </template>
                                <!--------------0 dollar-------only free_checkout payment method----------------------------------------->
                                <template
                                    v-if="payment_method == 'free_checkout' && paypalAmount <= 0.01 && isSignature == 0">
                                    <div class="row">
                                        <p class="label">Important note</p>
                                        <input type="text" placeholder="Important note" class="input"
                                            v-model="payinfo.note"></input>
                                    </div>
                                </template>

                                <!-- PayPal Checkout button is rendered in the footer area (same position as "Today You Pay") -->
                            </div>
                        </div>

                        <div class="modelbox" v-if="shouldShowBillingAddressFields()">
                            <div class="title">Billing address</div>
                            <div class="formbox">
                                <div class="row width">
                                    <p class="label">Billing Address <i>*</i></p>
                                    <input type="text" placeholder="Billing Address *" class="input required"
                                        data-parent="1" data-model="payinfo.address" v-model="payinfo.address" />
                                </div>
                                <div class="row" style='z-index:2;'>
                                    <p class="label">Country <i>*</i></p>
                                    <el-select :style="error_fields.includes('country') ? 'border: 1px solid red;' : ''"
                                        v-model="payinfo.country" class="input required" placeholder="Country"
                                        data-model="payinfo.country" data-parent="1"
                                        @change="getProvincies(payinfo.country)">
                                        <el-option v-if="countries" v-for="item in countries" :key="item.country_id"
                                            :label="item.name" :value="item.country_id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="row">
                                    <p class="label">City <i>*</i></p>
                                    <input type="text" placeholder="City" class="input required" data-parent="1"
                                        data-model="payinfo.city" v-model="payinfo.city" />
                                </div>
                                <div class="row" style='z-index:2;'>
                                    <p class="label">State/Province <i>*</i></p>
                                    <el-select v-model="payinfo.province" placeholder="State/Province"
                                        data-model="payinfo.province" class="input required" data-parent="1"
                                        @click="checkCountrySelection">

                                        <el-option v-if="curprovincies" v-for="(item, idx) in curprovincies" :key="idx"
                                            :label="item" :value="idx">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="row">
                                    <p class="label">Zip/Postal Code <i>*</i></p>
                                    <input type="text" placeholder="Zip/Postal Code" class="input required"
                                        data-parent="1" data-model="payinfo.postal" v-model="payinfo.postal" />
                                </div>
                            </div>
                        </div>

                        <div class="termFlight" v-if="flight_agree != ''">
                            <div class="fterm airfaretipscon">
                                <div class="label"><img src="/images/flight/icon_tipinfo.png" class="ico" alt="">
                                    Review the terms & conditions of your air booking.</div>
                                <div class="contxt">
                                    <p>{{ airDepositPolicy() }}</p>
                                    <p v-for="(ann, idx) in displayAnnouncements()" :key="idx">{{ ann }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="termFlightdiv" ref="termFlight" v-if="flight_agree != ''">
                            <el-checkbox class="acceptbox required " data-parent="1" data-model="checkedFlightTerm"
                                v-if="flight_agree != ''" v-model="checkedFlightTerm">
                                <span v-bind:class="{ 'trusted-html': flight_agree !== '' }" v-once
                                    v-html="flight_agree"></span>
                            </el-checkbox>
                        </div>

                        <div style="" class="product_policy_agree" v-if="generalPolicyLink != ''">
                            <el-checkbox class="acceptbox required" style="padding-right:1rem;" data-parent="1"
                                data-model="checkedTerm" v-model="checkedTerm">
                            </el-checkbox>

                            <div v-if="productPolicy == ''">I have read and agreed with the <span class='bold'
                                    @click="openGeneralPolicy()" style="color:#0099cc!important;">TripToGo General
                                    Policy</span> for my tour booking.</div>
                            <div v-else>I have read and agreed with the <span @click="openGeneralPolicy()" class='bold'
                                    style="color:#0099cc!important;">TripToGo General
                                    Policy</span> and the <span class='bold' @click='showProductPolicy = true'
                                    style="color:#0099cc!important;">Operator
                                    Policy</span> for my tour
                                booking.</div>
                        </div>
                        <div v-if="termsAgreeError" class="terms-agree-error">{{ termsAgreeError }}</div>
                    </div>

                    <div v-if="requiresSignatureAuthorization()">
                        <div class="modelbox" v-if="(visaAuthLevel % 3) > 0">
                            <div class="signature required" data-parent="0" data-model="code">
                                <div class="inputbox">
                                    <Signature @initCode="initCodeEvent" @mark="mark" ref="signatureRef"
                                        :signidx="signidx">
                                    </Signature>
                                </div>
                                <div class="tit verify">Verify your code</div>
                                <div class="txt">I authorize TripToGo to charge my credit card for the authorized
                                    amount. I understand that my information will be saved to file for future
                                    transactions on my account.</div>
                                <el-radio-group v-model="sendCodeType">
                                    <el-radio class="radio-border" value="1">Receive verification code by
                                        Email</el-radio>
                                    <el-radio class="radio-border" value="2" v-if="(visaAuthLevel % 3) == 2">Receive
                                        verification code by
                                        phone</el-radio>
                                </el-radio-group>
                                <div v-loading="verifyCodeLoading" :style="verifyCodeCountdown > 0 ? { 'opacity': 0.3 } : {}
                                    " class="btn" @click.stop="savePDF">{{ verifyCodeBtnText }}</div>
                            </div>
                        </div>
                        <div ref="verifyCodeElement" class="inputbox smscode required" data-parent="0"
                            data-model="signatured" v-if="code != ''">
                            <Smscode :code="code" :codeDesc="codeDesc" @resendCode="sendCode" @signDone="signDoneEvent"
                                :viewType="viewType">
                            </Smscode>
                        </div>
                    </div>
                    <!-- Popup -->
                </div>
            </div>
            <div class="summary-updating-wrap" :class="{ 'summary-updating': couponApplying }" :aria-busy="couponApplying">
                <div v-if="couponApplying" class="summary-updating__note" role="status">Updating your price…</div>
            <bookingSummary ref="bookingSummaryRef" :rmkey="rmkey" :odkey="odkey" :step="step" :offerSelected="offerSelected"
                :respond_id="respond_id" :refidx="refidx" :agentComm="agentComm" :chargeAmount="selectedPaymentTypeCharge()">
            </bookingSummary>
            </div>
        </div>
    </div>
    <div :class="{ 'paypal-fixed-footer': payment_method === 'paypal_checkout' }">
        <bookingFooter :rmkey="rmkey" :odkey="odkey" :cartref="'cartref'" :step="step" :steplist="orderStore.bookingSteps"
            @refreshStep="refreshStep" :btnTxt="btntxt" :hideBtn="payment_method === 'paypal_checkout'">
            <!-- PayPal button replaces the "Today You Pay" button when paypal_checkout is selected -->
            <template v-if="payment_method === 'paypal_checkout'" #extra>
                <PaypalButton
                    :client-id="paypalClientId"
                    :order-id="order_id"
                    :payment-id="payment_id"
                    :currency="paymentChargeCurrency()"
                    :amount="paypalAmount"
                    :disabled="paypalDisabled"
                    disabled-message=""
                    :before-create="beforePaypalCreate"
                    @disabled-click="onPaypalDisabledClick"
                    @payment-success="onPaypalSuccess"
                    @payment-fail="onPaypalFail"
                    @payment-cancel="onPaypalCancel"
                    style="flex: 1; min-width: 0;"
                />
            </template>
        </bookingFooter>
    </div>
    <termDialog v-if="dialogVisible && termContent != ''" @termConfirm="termConfirm" :termContent="termContent">
    </termDialog>
    <alertDialog v-if="reservation" @closeWin="closeReservation" :status="'success'" :img="alertSetting.reservation.img"
        :btnsetting="alertSetting.reservation.btn" :title="''" :content="alertSetting.reservation.content" />
    <alertDialog v-if="payFail" @closeWin="closePayFail" :status="'success'" :img="alertSetting.payFail.img"
        :btnsetting="alertSetting.payFail.btn" :title="''" :content="payFailMessage" />
    <alertDialog v-if="signWindow" @closeWin="closeSignWin" :status="'success'" :img="alertSetting.sign.img"
        :customerClass="'customWin'" :btnsetting="alertSetting.sign.btn" :title="alertSetting.sign.title"
        :content="alertSetting.sign.content" />
    <!-- Payment success -->
    <Teleport to="body">
        <div class="prop pay-success-overlay" v-if="showPaySucc" role="dialog" aria-modal="true" aria-labelledby="payment-success-title">
            <div class="con pay-success-con" @click.stop="">
                <div class="block customer_popwin">
                    <div class="r childcenter">
                        <div class='win_img'><img src="/images/icon_suc.png" alt=""></div>
                    </div>
                    <div class="r childcenter">
                        <div id="payment-success-title" class='win_title'>Thank You</div>
                    </div>
                    <div class="r pay-success-copy">
                        <div class="win_con">An automated receipt will be sent to your registered email. You can also view
                            your receipt in the 'My Booking Details' section of your account.</div>
                        <div class="win_con">Invite your friends to join this tour and earn up to <span
                                style="font-weight: bold;">100 reward points!</span></div>
                    </div>
                    <div class="r childcenter pay-success-actions">
                        <div class="button" @click="this.closePaySuccWin()">Go To My Bookings</div>
                        <div class="button refer" @click="ToUrl('/user/?active=6')">Refer a Friend</div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>


    <!-- product policy -->
    <div class="prop " v-if="showProductPolicy">
        <div class="con" @click.stop="">

            <div class="closer fixed_closer" @click="showProductPolicy = false">
                <img src="/images/icon_close.png" />
            </div>

            <!--    <div class="closer">
                <img src="/images/icon_close.png" @click="showProductPolicy = false" />
            </div>
 -->
            <div class="pop_con">
                <div class="block product_policy">

                    <div class="r childcenter">
                        <div v-html="productPolicyName" class="name"></div>
                    </div>
                    <div class="r">
                        <div v-html="productPolicy"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- general policy -->
    <div class="prop " v-if="showGeneralPolicy">
        <div class="con" @click.stop="">
            <!--     <div class="closer">
                <img src="/images/icon_close.png" @click="showGeneralPolicy = false" />
            </div> -->

            <div class="closer fixed_closer" @click="showGeneralPolicy = false">
                <img src="/images/icon_close.png" />
            </div>

            <div class="pop_con">
                <div class="block product_policy">

                    <div class="r childcenter">
                        <div class="name">Terms & Conditions</div>
                    </div>
                    <div class="r">
                        <div v-html="termContent"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import bookingHeader from "@/components/bookingHeader.vue";
import bookingFooter from "@/components/bookingFooter.vue";
import bookingSummary from "@/components/bookingSummary.vue";
import { jsPost, scrollToPosition, scrollWindow, priceAmount, notEmpty, priceFormat, isNull,pagePriceFormat } from "@/utils/tool.js";
import {  pagelog } from '@/utils/pagelog'
import Request from '@/services/Request.ts';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { exposeAuthorizationPdfFormValues } from '@/utils/authorizationPdfCapture';
import termDialog from "./termDialog.vue";
import { nextTick } from "vue";
import alertDialog from '@/components/alertdialog.vue';
import Signature from "./signature.vue";
import Smscode from "./smscode.vue";
import { formatAddress } from "@/utils/AddressUtils";
import ImService from "@/services/ImService";
import InquiryService from '@/services/InquiryService';
import * as Sentry from "@sentry/vue";
import { trackBeginCheckout } from '@/utils/FunnelAnalytics'
import { useCartStore } from "@/stores/CartStore";
import { useOrderStore } from "@/stores/OrderStore";
import { useInsuranceStore } from "@/stores/InsuranceStore";
import { useCurrencyStore } from "@/stores/CurrencyStore";
import { getCaptchaToken } from "@/utils/ReCaptchaUtils";
import { localDriver } from '@/utils/localDriver'
import PaypalButton from '@/components/PaypalButton.vue'
import { loadStripe } from '@stripe/stripe-js'
import { classifyPaypalFailure, sortPaymentMethods } from '@/utils/paymentMethods'

export default {
    components: {
        bookingHeader: bookingHeader,
        bookingFooter: bookingFooter,
        bookingSummary: bookingSummary,
        termDialog: termDialog,
        Signature,
        Smscode,
        alertDialog,
        PaypalButton,
    },
    setup() {
        const cart = useCartStore();
        const orderStore = useOrderStore();
        const insuranceStore = useInsuranceStore();
        const currencyStore = useCurrencyStore();

        return {
            cart,
            orderStore,
            insuranceStore,
            currencyStore,
        }
    },
    data() {
        return {
            pagelog,
            scrollWindow,
            pagePriceFormat,
            isNull,
            odata: {},
            roomlist: [],
            voucher: '',
            pressnum: 3,
            step: 4,
            refidx: 2000,
            btntxt: { txt: 'Continue', status: 0 },
            paySubmitting: false,
            payRequestInFlight: false,
            noFptrip: 0,
            steplist: [
                { title: 'Flight Preference', path: 'flight' },
                { title: 'Order Filling', path: 'booking' },
                { title: 'Checkout/Payment', path: 'payment' },
            ],
            ismobile: false,
            isFilters: false,
            ischeck1: false,
            ischeck2: false,
            ischeck3: false,
            ischeck4: false,
            ischeck5: false,
            verifyCodeCountdown: 0,
            verifyCodeLoading: false,
            verifyCodeBtnText: "Save and Send Code",
            verifyCodeTimer: null,
            Baggage: ['1Bag'],
            Preferred: ['Basiceconomy'],
            Stops: ['Nonstop'],
            Preferred: ['Lufthansaairline'],
            Sort: ['Price(lowest)'],
            alertSetting: {
                sign: {
                    img: 'mdi_sign.png',
                    title: 'Signature Capture Failed',
                    content: 'Oops! We couldn’t capture your signature. Please try signing again.',
                    btn: {
                        txt: 'Close',
                        style: 'background:#FFFFFF;color:#000000;border:1px solid #888888;width:70%;',
                    },
                },
                reservation: {
                    btn: {
                        txt: 'Select Another Date',
                        bg: '#00F1BD',
                        color: '#000000'
                    },
                    img: 'date_search.png',
                    content: 'Oops! Looks like we don\'t have enough availability for the date you selected. Please adjust your reservation or try selecting an alternate date.',
                },
                payFail: {
                    btn: {
                        txt: 'Close',
                        bg: '#EAEAEA',
                        color: '#000000'
                    },
                    img: 'No_Credit_Cards.png',
                    content: "Your Credit Card Was Declined: A declined credit card transaction can occur due to reasons like insufficient funds, expired cards, incorrect card number or billing information, bank security measures, please double-check your details or contact your bank for assistance.",

                /*     content: 'The information of your credit card appears to be incorrect. Please check carefully and re-enter the details.',
 */                }
            },
            peoplelist: [],
            showselTravBox: false,
            showaddTravBox: false,
            dataForm: {
                phonenum: '+86',
                amount: 'full'
            },
            showHotelBox: false,
            people: [],

            offerSelected: -1,
            respond_id: 0,
            flightOffer: {},
            authorization: 0,
            customerInfo: { customer_id: 0, customer_name: '', avater: '', has_company: 0 },
            //triptogo shenzhen
            discounts: {
                coupon: '',
                credit: [],
                total: []
            },
            couponErr: '',
            credits: [],
            coinCredits: [],
            alltraveler: [],
            order_id: 0,
            payment_id: 0,
            netprice: 0,
            agentcomm_status: false,
            agentComm:'',
            payinfo: {},
            visaAuthLevel: 0,
            coinsHidden:0,
            checkedTerm: false,
            checkedFlightTerm: false,
            // Shown near the terms checkbox when PayPal click is blocked by missing agreement;
            // paired with the .redborder added by payoutValidation() on the terms container.
            termsAgreeError: "",
            text_agree: "",
            dialogVisible: false,
            termContent: "",
            payment_method: "",
            payment_type: "",
            payment_types: [],
            paypalAmount: 0,
            paypalClientId: '',
            stripe: null,
            cardElement: { cardNumber: null, cardExpiry: null, cardCvc: null },
            stripeMounting: null,
            public_key: '',
            payment_methods: [],
            all_methods: [],
            payment_method_type: {
                eselectplus_api: ["Master", "Visa"],
                moneris_installation_api: ["Master", "Visa"],
                pp_pro: ["Master", "Visa", "AMEX"],
            },
            payment_credit: { price: 0, price_format: "", amount: 0, currency: "USD" },
            remainingAmount: 0,  // Remaining amount to be paid
            remainingAmountFormatted: '',  // Formatted remaining amount
            rewardsPointBalance: '',  // Formatted points balance
            signWindow: false,
            isSepCredit: 0,
            signatured: 0,
            sendCodeType: '1',
            signFileid: 0,
            code: '',
            customer_id: 0,
            viewType: 0,
            discountboxShow: false,
            couponPlaceHolder: 'Enter Your Voucher Code',
            countries: [],
            provincies: [],
            curprovincies: [],
            datePickerOptions: {
                disabledDate(date) {
                    const today = new Date();
                    const thisYear = today.getFullYear();
                    const thisMonth = today.getMonth();
                    const nextMonth = new Date(thisYear, thisMonth + 1, 1);
                    return date < nextMonth;
                }
            },
            ismark: 0,
            codeDesc: "We've sent you a text message. Please enter the code below.",
            reservation: false,
            error_fields: [],
            Announcements: [],
            flight_agree: '',
            productPolicy: "",
            productPolicyName: "",
            showProductPolicy: false,
            showGeneralPolicy: false,
            generalPolicyLink: "",
            canvasObj: null,
            showPaySucc: false,
            payFail: false,
            defaultPayFailMessage: "Your Credit Card Was Declined: A declined credit card transaction can occur due to reasons like insufficient funds, expired cards, incorrect card number or billing information, bank security measures, please double-check your details or contact your bank for assistance.",
            cartPayFailMessage: "Your cart is no longer valid. Please return to the booking page, review traveler and option information, then try payment again.",
            reservationPayFailMessage: "This departure date is no longer available. Please select another date and try again.",
            paypalPayFailMessage: "PayPal could not complete this payment. Please try again or use another payment method.",
            paymentPendingMessage: "We could not confirm whether your card payment completed. Do not submit payment again. Check My Bookings or contact support before retrying.",
            checkoutRequestFailMessage: "We could not start the payment request. No card confirmation was sent. Please try again.",
            paymentNotCompletedMessage: "The card payment was not completed. Please check your card details and try again.",
            payFailMessage: "Your Credit Card Was Declined: A declined credit card transaction can occur due to reasons like insufficient funds, expired cards, incorrect card number or billing information, bank security measures, please double-check your details or contact your bank for assistance.",
            paymentPending: false,
            newoid: 0,
            signidx: 0,
            radioValue: '',
            gatewayopen: false,
            haslog: false,
            rmkey: '',
            odkey: '',
            appliedGrouponCodes:[],
            // A coupon / Groupon apply is waiting for checkout/checkout to recalculate the totals.
            couponApplying: false,
            mystery_coupon:'',
            applyCouponIdx:0,
            ppProHideEselectPlus: true,
            // Backend setting_ext payment_prefer_moneris_currencies: keep Moneris and select it by default.
            preferMoneris: false,
			FlightExcludePPC:false,
        };
    },
    watch: {
        code(newValue, oldValue) {
            if (newValue != null && newValue != "") {
                nextTick(() => {
                    this.$refs.verifyCodeElement.scrollIntoView({
                        behavior: "smooth"
                    })
                })
            }
        },
        "payinfo.country":
        {
            handler(newValue, oldValue) {
                if (this.error_fields.includes("country")) {
                    const index = this.error_fields.indexOf("country");
                    if (index > -1) {
                        this.error_fields.splice(index, 1);
                    }
                }
                // Country can be filled from the saved address without a change event; load its states here.
                this.getProvincies(newValue);
            }, deep: true
        },
        payment_type: {
            async handler(newValue, oldValue) {
                for (var i in this.payment_methods) {
                    this.payment_methods[i].zerotype = this.zerotype(this.payment_methods[i]);
                }
                await this.checkCreditAmt();
                await this.getValidMethod(); // Re-filter methods (e.g. hide paypal_checkout for deposit)
                this.radioValue = newValue;
            },
            deep: true
        },
        payment_method: {
            async handler(newValue, oldValue) {
                await this.getCurpayment();
                this.paypalAmount = await this.checkPayment(1);
                if (newValue === 'stripe') {
                    await this.mountStripeElements();
                }
            },
            deep: true
        },
        // The Stripe publishable key arrives with the payment methods; the default method may already be stripe.
        public_key(newValue) {
            if (newValue && this.payment_method === 'stripe') {
                this.mountStripeElements();
            }
        },
        // validPaymentMethod() depends on paypalAmount, which is only known after a method
        // is picked; when the visible options change, move a now-hidden gateway selection
        // to the first visible option.
        visiblePaymentMethodCodes(codes) {
            const amountDriven = ['Payment_Transfer', 'free_checkout']
            // A hidden amount-driven code (e.g. Payment_Transfer once there is something to
            // charge) must move too, or el-select shows the raw code.
            if (!this.payment_method || codes.includes(this.payment_method)) return
            // Zero amount: only free_checkout or Payment_Transfer is visible, so fall back to it.
            const gatewayCode = codes.find(code => !amountDriven.includes(code)) || codes[0]
            if (gatewayCode) {
                this.payment_method = gatewayCode
            }
        },
        isSepCredit: {
            async handler(newValue) {
                const splitEnabled = newValue === true || newValue === 1 || newValue === '1';
                if (!splitEnabled && parseFloat(this.payment_credit?.amount || 0) > 0) {
                    this.payment_credit.amount = 0;
                }
                await this.getValidMethod();
                await this.getCurpayment();
                await this.updateRemainingAmount();
            },
            deep: true
        },
        maxCoinValue(newMax) {
            const current = parseFloat(this.payment_credit?.amount || 0);
            if (current > newMax) {
                this.payment_credit.amount = newMax;
                this.checkCreditAmt();
            }
        },
        payinfo: {
            handler(newValue, oldValue) {
                this.btntxtStatus();
                this.signidx++;
                this.handleAuthSensitiveChange();
            },
            deep: true
        },
        checkedFlightTerm: {
            handler(newValue, oldValue) {
                this.btntxtStatus();
                this.signidx++;
                if (newValue) this.clearTermsAgreeError();
            },
        },
        checkedTerm: {
            handler(newValue, oldValue) {
                this.btntxtStatus();
                this.signidx++;
                if (newValue) this.clearTermsAgreeError();
            },
        },
        signatured: {
            handler(newValue, oldValue) {
                this.btntxtStatus();
            },
            deep: true
        },
        // netprice:{
        //     async handler(newValue, oldValue) {
        //         await this.paymentGate({});
        //     },
        //     deep: true            
        // }
    },
    async mounted() {
        this.haslog = (!window.location.href.includes('www.triptogo.com'));
        this.pagelog(new Request(), 'payment_loading');
        // Track begin_checkout event for funnel analytics
        trackBeginCheckout()
        this.ismobile = (document.documentElement.clientWidth < 750);
        this.tokenInit();
        await this.currencyStore.fetchCurrencies()
        const stripeReturnIntentId = new URL(window.location.href).searchParams.get('intentId');
        if (stripeReturnIntentId) {
            this.paymentPending = true;
            this.gatewayopen = false;
            this.btntxt.status = 0;
        }
        //charls added this, temporary comment it to avoid 'depart_date' error, still need more test and confirm with charls
        this.customer_id = await localDriver.getItem('customer_id') || 0;
        //console.log('------------------this.customer_id--------------', this.customer_id)
        this.odata = await localDriver.getItem(this.odkey) || 0;
        if (this.odata?.pageCurrency || this.odata?.currency) {
            this.currencyStore.setDisplayCurrency(this.odata.pageCurrency || this.odata.currency)
        }
        this.currencyStore.lockCurrency()
        if (!this.odata) {
            if (stripeReturnIntentId) {
                await this.completeStripeReturn(stripeReturnIntentId);
                return;
            }
            this.checkExistToken()
            return
        }
        try {
            await this.$nextTick()
            scrollToPosition(document.getElementById('paymentPage'), -20);
            this.odata.groupon_codes = await this.getGrouponCodes();
            this.roomlist = await localDriver.getItem(this.rmkey)
            console.log('------------------this.odata-------------', this.odata);
            if (this.odata) {                
                this.roomlist = await localDriver.getItem(this.rmkey) || {}
                await this.insuranceStore.buildQuoteInfo(this.odata, null, this.roomlist)
                let product_id = this.odata.product_id;
                this.getProductPolicy(product_id);
                this.noFptrip = (this.odata.product_info.model.toUpperCase().slice(0, 3) !== 'FP-');        //(('flightOffer' in this.odata) && (this.odata.flightOffer.id > 0) && )
                await this.customerRefresh();
                await this.initPayment();
                await this.getCurpayment();
                await this.updateRemainingAmount();  // Initialize remaining amount
                this.payinfo = {
                    date: "",
                    authorization: 0,
                    number: '',
                };
                await this.hasFlightSign();
                if (this.odata.groupon_codes?.length > 0) {
                    await this.applyCoupon(2);
                }
            }
        }
        catch (e) {
            // Continue to the saved PaymentIntent recovery below if regular page setup fails.
        }
        if (stripeReturnIntentId) {
            await this.completeStripeReturn(stripeReturnIntentId);
        }
    },
    beforeUnmount() {
        this.clearVerifyCodeTimer();
    },
    computed: {
        visiblePaymentMethodCodes() {
            return (this.payment_methods || [])
                .filter(item => this.validPaymentMethod(item))
                .map(item => item.code)
        },
        // Gate PayPal checkout's onClick so the popup never opens until terms + gateway are ready.
        // Without this, PayPal opens its popup, beforePaypalCreate throws, onError emits payment-fail,
        // and the "Credit Card Was Declined" dialog pops up for what is really a missing checkbox.
        paypalDisabled(){
            if (!this.gatewayopen) return true;
            if (this.generalPolicyLink !== '' && !this.checkedTerm) return true;
            if (this.flight_agree !== '' && !this.checkedFlightTerm) return true;
            if (!this.payment_method_valid()) return true;
            return false;
        },
        maxCoinValue() {
            const insuranceAmount = parseFloat(this.insuranceStore.unPayDisplay??(this.insuranceStore.unPay??0))
            const price = parseFloat(this.payment_credit.price || 0)
            let payment_amt = 0 

            for (var i in this.payment_types) {
                if (this.payment_types[i].title.toLowerCase() === this.payment_type.toLowerCase()) {
                    payment_amt = parseFloat(this.payment_types[i].amount) - insuranceAmount;
                    break;
                }
            }
            const max = Math.min(price, payment_amt)
            return max
        },
        isSignature(){
            // Signature authorization is required when both hold:
            // 1. payment method is eselectplus_api,
            // 2. the order includes an API flight (flightOffer.rid > 0), including FP- packages.
            return (this.payment_method == 'eselectplus_api' && this.hasApiFlight()) ? 1 : 0;
        }
    },
    methods: {
		isSplitCreditEnabled() {
            return this.isSepCredit === true || this.isSepCredit === 1 || this.isSepCredit === '1';
        },
        isZeroAmountCheckout() {
            return Math.max(0, parseFloat(this.remainingAmount || 0) || 0) <= 0.01;
        },
        removeGrouponVoucherCode(code){
            this.appliedGrouponCodes = [];
            this.applyCoupon(3);
        },
        async getGrouponCodes(){            
           return await new Promise((resolve) => {
                        new Request().webPost(
                            { groupon_order_id: this.odata.groupon_order_id },
                            (res) => {
                                resolve(Array.isArray(res?.codes) ? res.codes : [])
                            },
                            'product/groupon_booking/getCodes'
                        )
                    })  
        },
        requiresSignatureAuthorization() {
            return this.isSignature > 0 && !this.isZeroAmountCheckout();
        },
        shouldShowCardPaymentFields() {
            if (this.isZeroAmountCheckout()) {
                return false;
            }
            return ((this.payment_method == 'eselectplus_api' || this.payment_method == 'pp_pro')
                || (this.payment_method == 'Payment_Transfer' && parseFloat(this.remainingAmount || 0) > 0))
                || this.requiresSignatureAuthorization();
        },
        shouldShowBillingAddressFields() {
            if (this.isZeroAmountCheckout()) {
                return false;
            }
            return ((this.payment_method == 'eselectplus_api' || this.payment_method == 'pp_pro' || this.payment_method == 'stripe')
                || (this.payment_method == 'Payment_Transfer' && parseFloat(this.remainingAmount || 0) > 0))
                || this.requiresSignatureAuthorization();
        },
        canUseSplitCredit() {
            return this.payment_credit.price > 0 && !this.coinsHidden && this.selectedPaymentTypeAmount() > 0;
        },
        shouldUseSeparateCredit() {
            return this.canUseSplitCredit() && parseFloat(this.payment_credit?.amount || 0) > 0;
        },
        async isInsuranceOnlyRemainingPayment() {
            if (!this.insuranceStore.needPurchase()) {
                return false;
            }

            const remainingAmount = Math.max(0, parseFloat(await this.checkPayment(1)) || 0);
            const insuranceAmount = Math.max(0, parseFloat(this.insuranceStore?.unPayDisplay??(this.insuranceStore.unPay || 0)) || 0);

            return remainingAmount > 0 && insuranceAmount > 0 && Math.abs(remainingAmount - insuranceAmount) < 0.01;
        },
        getSelectedCreditIds() {
            const selectedIds = Array.isArray(this.discounts.credit)
                ? this.discounts.credit.filter(id => notEmpty(id))
                : [];

            if (selectedIds.length > 0) {
                return selectedIds;
            }

            if (parseFloat(this.payment_credit?.amount || 0) > 0 && Array.isArray(this.coinCredits) && this.coinCredits.length > 0) {
                return this.coinCredits
                    .map(item => item?.ctid)
                    .filter(id => notEmpty(id));
            }

            return [];
        },
        // What the gateway charges today for the selected payment type, for the booking summary.
        selectedPaymentTypeCharge() {
            const currentType = String(this.payment_type || '').toLowerCase();
            const selectedType = this.payment_types.find(
                (item) => String(item?.title || '').toLowerCase() === currentType
            );
            return selectedType ? { amount: parseFloat(selectedType.amount || 0), currency: selectedType.currency || '' } : null;
        },
        // Currency of the selected payment type: the amount from checkPayment(1) is in this currency.
        paymentChargeCurrency() {
            return this.selectedPaymentTypeCharge()?.currency || this.odata?.pageCurrency || this.odata?.currency || 'USD';
        },
        selectedPaymentTypeAmount() {
            const currentType = String(this.payment_type || '').toLowerCase();
            const selectedType = this.payment_types.find(
                (item) => String(item?.title || '').toLowerCase() === currentType
            );
            return parseFloat(selectedType?.amount || 0);
        },
        async precheckBeforePayout() {
            const tokenUsable = await new Promise((resolve) => {
                new Request().webPost(
                    { token: this.orderStore.token },
                    (res) => {
                        // Existing checkExistToken logic treats success=true as invalid/expired token state.
                        resolve(!(res?.success === true));
                    },
                    'checkout/cart/checkToken',
                    () => {
                        resolve(false);
                    }
                );
            });

            if (!tokenUsable) {
                this.openPayFail('error_cart');
                return false;
            }

            const checkoutUsable = await new Promise((resolve) => {
                const d = {
                    v: 202003,
                    netprice: parseInt(this.netprice) + 1,
                    token: this.orderStore.token,
                    csyn: 1
                };
                new Request().webPost(
                    d,
                    (res) => {
                        if (res?.reservation === 1) {
                            resolve('reservation_unavailable');
                            return;
                        }
                        if (res?.success === false && !(res?.shopping_cart || res?.payment_type)) {
                            resolve('error_cart');
                            return;
                        }
                        resolve('ok');
                    },
                    'checkout/checkout',
                    () => {
                        resolve('error_cart');
                    }
                );
            });

            if (checkoutUsable !== 'ok') {
                this.openPayFail(checkoutUsable);
                return false;
            }

            return true;
        },
        checkExistToken() {
            new Request().webPost(
                { token: this.orderStore.token },
                (res) => {
                    if (res.success) {
                        if (res?.redirect ?? false) {
                            window.location.href = '/booking/insurance?tk=' + this.orderStore.token
                        }
                        else {
                            window.location.href = '/'
                        }
                    }
                },
                'checkout/cart/checkToken'
            )
        },
        rd(amt, ln) {
            // ponytail: amt can arrive as a string from the API — coerce before toFixed.
            return (Number(amt) || 0).toFixed(ln);
        },
        tokenInit() {
            let token = this.orderStore.token;
            this.odkey = 'order_data_' + token;
            this.rmkey = 'roomlist_' + token;
        },
        async changeAgentPayemt(idx) {
            this.netprice = idx;
            await this.paymentGate({});
        },
        outDays(dpdate, days) {
            return days != 0 && (new Date().nextDate(days).getFullstring().slice(0, 10) < dpdate);
        },
        hasApiFlight() {
            return (this.odata?.flightOffer?.rid ?? 0) > 0;
        },
        firstVisiblePaymentMethodCode() {
            const visible = (this.payment_methods || []).find(item => this.validPaymentMethod(item))
            return visible ? visible.code : ''
        },
        // Must stay synchronous: v-if gets a Promise (always truthy) from an async method.
        // Never leaves the dropdown empty: when the rules match nothing, every card gateway shows.
        validPaymentMethod(item) {
            if (this.paymentMethodMatchesAmount(item)) return true
            const amountDriven = ['free_checkout', 'Payment_Transfer']
            return !amountDriven.includes(item.code)
                && !(this.payment_methods || []).some(method => this.paymentMethodMatchesAmount(method))
        },
        // Method used when nothing is left to charge: Payment_Transfer when TTG Coins were applied
        // (and the gateway list offers it), otherwise free_checkout.
        zeroAmountMethodCode() {
            const coinUsed = parseFloat(this.payment_credit?.amount || 0) > 0
            const hasTransfer = Object.values(this.all_methods || {}).some(method => method?.code === 'Payment_Transfer')
            return coinUsed && hasTransfer ? 'Payment_Transfer' : 'free_checkout'
        },
        paymentMethodMatchesAmount(item) {
            const insurranceAmt = parseFloat(this.insuranceStore.unPayDisplay??(this.insuranceStore.unPay??0)) || 0
            // Insurance to pay: it is charged to a card for the insurer, so PayPal Pro / Moneris come first.
            if (insurranceAmt > 0) {
                return item.code == 'eselectplus_api' || item.code == 'pp_pro' || item.code == 'stripe'
            }
            // Nothing to charge: Payment_Transfer first when TTG Coins were applied.
            if (parseFloat(this.paypalAmount || 0) <= 0.01) {
                return item.code == this.zeroAmountMethodCode()
            }
            return item.code != 'free_checkout' && item.code != 'Payment_Transfer'
        },
        airDepositPolicy() {
            let persons = 0;
            for (let i in this.roomlist) {
                persons += (parseInt(this.roomlist[i].Adults) + parseInt(this.roomlist[i].Child));
            }
            persons = persons ? persons : 1;
            let dp_amt = 0;
            if (notEmpty(this.odata.flightOffer) && notEmpty(this.odata.flightOffer.deposit) && this.odata.flightOffer.deposit > 0) {
                dp_amt = parseFloat(this.odata.flightOffer.deposit)
            }

            if (notEmpty(this.odata.flightOffer) && ('info' in this.odata.flightOffer) && this.odata.flightOffer.info.type == 'tba') {
                return '';
            }
            else {
                const curentAmount = priceFormat(this.odata.currency, dp_amt > 0 ? dp_amt : this.odata.flights_amount, ',', 2, 1)
                return 'Your air deposit of ' + curentAmount + ' amount.';
            }
        },
        displayAnnouncements() {
            if (!Array.isArray(this.Announcements)) {
                return [];
            }
            if (!this.shouldApplyMembershipRefundWording(this.odata)) {
                return this.Announcements;
            }
            const depositWord = this.getMembershipDepositWord();
            if (!depositWord) {
                return this.Announcements;
            }
            return this.Announcements.map((line) => {
                const content = String(line ?? '');
                if (!/your\s+(?:non-refundable|refundable)\s+air deposit is/i.test(content)) {
                    return content;
                }
                return content.replace(/(your\s+)(?:non-refundable|refundable)(\s+air deposit is)/i, `$1${depositWord}$2`);
            });
        },
        getMembershipDepositWord() {
            const memberType = this.resolveMemberType(this.odata);
            const explicitWord = String(this.odata?.membership_refund_deposit_word ?? '').trim().toLowerCase();
            if (memberType === 1 || memberType === 10) {
                if (explicitWord === 'non-refundable' || explicitWord === 'refundable') return explicitWord;
                return 'non-refundable';
            }
            if (memberType >= 2) return 'refundable';
            return '';
        },
        parseMemberTypeValue(raw) {
            if (raw == null) return 0;
            if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
            if (Array.isArray(raw)) {
                for (const item of raw) {
                    const parsed = this.parseMemberTypeValue(item);
                    if (parsed > 0) return parsed;
                }
                return 0;
            }
            if (typeof raw === 'object') {
                const nested = [
                    raw?.membershiptype_id,
                    raw?.member_type,
                    raw?.type_id,
                    raw?.membershipType,
                    raw?.mmshiptypeid,
                    raw?.name,
                    raw?.title,
                    raw?.label,
                    raw?.text,
                ];
                for (const item of nested) {
                    const parsed = this.parseMemberTypeValue(item);
                    if (parsed > 0) return parsed;
                }
                return 0;
            }
            let text = '';
            try {
                text = String(raw).trim().toLowerCase();
            } catch (e) {
                return 0;
            }
            if (!text) return 0;
            if (text.includes('inside')) return 1;
            if (text.includes('insider')) return 1;
            if (text.includes('pathfinder')) return 10;
            if (text.includes('voyager')) return 2;
            if (text.includes('adventurer')) return 3;
            if (text.includes('elite')) return 4;
            const n = parseInt(text, 10);
            return Number.isFinite(n) ? n : 0;
        },
        resolveMemberType(odata) {
            const c = this.customerInfo || {};
            return this.parseMemberTypeValue(
                c.member_type
                ?? c.memberType
                ?? c?.mmshipHistory?.[0]?.mmshiptypeid
                ?? c?.mmshipHistory?.[0]?.description
                ?? c?.mmshipHistory?.[0]?.name
                ?? c?.membership
            );
        },
        shouldApplyMembershipRefundWording(odata) {
            const memberType = this.resolveMemberType(odata);
            const candidates = this.getMembershipRefundCandidates(odata);
            const hasMembershipRule = candidates.some((source) => this.isMembershipRefundSourceEnabled(source));
            const hasAnnouncement = this.hasAirDepositAnnouncement();
            return memberType > 0 && hasMembershipRule && hasAnnouncement;
        },
        hasFlightDeposit(odata) {
            return parseFloat(odata?.flightOffer?.deposit ?? 0) > 0;
        },
        hasAirDepositAnnouncement() {
            if (!Array.isArray(this.Announcements)) return false;
            return this.Announcements.some((line) =>
                /your\s+(?:non-refundable|refundable)\s+air deposit is/i.test(String(line ?? ''))
            );
        },
        hasMembershipRefundTerm(odata) {
            return this.getMembershipRefundCandidates(odata).some((source) =>
                this.isMembershipRefundSourceEnabled(source)
            );
        },
        getMembershipRefundCandidates(odata) {
            return [
                odata?.flightOffer?.info?.refund_term,
                odata?.flightOffer?.info?.refund_terms,
                odata?.flightOffer?.info?.refundTerm,
                odata?.flightOffer?.info?.refundTerms,
                odata?.flightOffer?.info?.rule_id,
                odata?.flightOffer?.info?.ruleId,
                odata?.flightOffer?.rule_id,
                odata?.flightOffer?.ruleId,
                odata?.flightOffer?.refund_term,
                odata?.flightOffer?.refund_terms,
                odata?.flightOffer?.refundTerm,
                odata?.flightOffer?.refundTerms,
                odata?.tripFlightInfo?.rule_id,
                odata?.tripFlightInfo?.ruleId,
                odata?.tripFlightInfo?.refund_term,
                odata?.tripFlightInfo?.refund_terms,
                odata?.tripFlightInfo?.refundTerm,
                odata?.tripFlightInfo?.refundTerms,
                odata?.product_info?.refund_term,
                odata?.product_info?.refund_terms,
                odata?.product_info?.refundTerm,
                odata?.product_info?.refundTerms,
                odata?.product_info?.rule_id,
                odata?.product_info?.ruleId,
                odata?.refund_term,
                odata?.refund_terms,
                odata?.refundTerm,
                odata?.refundTerms,
                odata?.rule_id,
                odata?.ruleId,
                odata?.membership_refund_rule_applied,
                odata?.membershipRefundRuleApplied,
            ];
        },
        isMembershipRefundSourceEnabled(source) {
            if (source == null) return false;
            if (typeof source === 'number') return source > 0;
            if (typeof source === 'string') {
                const text = source.trim();
                if (!text) return false;
                if (/^-?\d+(\.\d+)?$/.test(text)) return Number(text) > 0;
                if (text === '[]' || text === '{}') return false;
                return true;
            }
            if (Array.isArray(source)) return source.some((item) => this.isMembershipRefundSourceEnabled(item));
            if (typeof source === 'object') {
                const values = Object.values(source);
                if (values.length === 0) return false;
                return values.some((item) => this.isMembershipRefundSourceEnabled(item));
            }
            return false;
        },
        disabledDate(time) {
            const date = new Date()
            const previousDate = date.setDate(date.getDate() - 1)
            return time.getTime() < previousDate
        },
        GoogleTrack(orderId, price, currency) {
            window.dataLayer = window.dataLayer || [];
            function gtag() {
                window.dataLayer.push(arguments);
            }
            gtag('js', new Date());

            gtag('config', 'G-W40VDZ6Z7L', { cookie_flags: 'secure' });

            // Build GA4 purchase payload from odata (fallback to generic item)
            const items = [];
            try {
                if (this.odata) {
                    const productId = this.odata.product_id || this.odata.productId || orderId;
                    const productName = this.odata.product_name || this.odata.productName || 'booking';
                    const quantity = this.odata.quantity || 1;
                    items.push({
                        item_id: productId,
                        item_name: productName,
                        price: price,
                        currency: currency,
                        quantity: quantity
                    });
                }
            } catch (e) {
                // ignore and use fallback
            }
            if (items.length === 0) {
                items.push({
                    item_id: orderId,
                    item_name: 'booking',
                    price: price,
                    currency: currency,
                    quantity: 1
                });
            }

            // GA4 purchase event
            gtag('event', 'purchase', {
                transaction_id: orderId,
                value: price,
                currency: currency,
                items: items
            });

            // Google Ads conversion event
            gtag('event', 'conversion', {
                'send_to': 'AW-16693022768/tUFLCOf65dEZELCg7Zc-',
                'transaction_id': orderId,
                'value': price,
                'currency': currency
            });
            //console.log("tracked");
        },
        ToUrl(url) {
            document.location = url;
        },
        closePaySuccWin() {
            this.showPaySucc = false;
            this.clearVerifyCodeTimer();
            if (this.newoid != "") {
                let url = "/user/?active=2";     //"/user/bookings/?id=" + this.newoid;
                //console.log(url);
                window.location = url;
            }

        },
        openGeneralPolicy() {
            const link = this.generalPolicyLink;
            const urlObj = new URL(link);
            const params = new URLSearchParams(urlObj.search);
            const url = params.get('route') + '&information_id=' + params.get('information_id') +
                '&display_currency=' + encodeURIComponent(this.odata?.currency || '')
            new Request().webGet(
                {},
                res => {
                    if (res.data ?? false) {
                        this.termContent = res.data
                        this.showGeneralPolicy = true
                    }
                },
                url
            );
        },
        getProductPolicy(produt_id) {
            new Request().webGet(
                {},
                res => {
                    //console.log("---getProductPolicy---", res);
                    if (res.success) {
                        this.productPolicy = res.data.description;
                        this.productPolicyName = res.data.name.split('@')[0];
                    }
                },
                "product/common/getPolicy&product_id=" + produt_id + "&display_currency=" + encodeURIComponent(this.odata?.currency || '')
            );
        },
        async checkCreditAmt() {            
            await this.getValidMethod();
            await this.getCurpayment();
        },
        formatPaymentCreditInput(value) {
            const amount = parseFloat(value || 0);
            if (!Number.isFinite(amount) || amount <= 0) {
                return 0;
            }
            return amount.toFixed(2);
        },
        async updateRemainingAmount() {
            this.remainingAmount = await this.checkPayment(1);
            if(this.insuranceStore.unPay>0 && this.insuranceStore.unPay!=this.insuranceStore.unPayDisplay)
            {
                this.remainingAmountFormatted = pagePriceFormat(
                    {currency:this.odata.currency,amount:this.remainingAmount - this.insuranceStore.unPayDisplay},
                    {currency:'USD',amount:this.insuranceStore.unPay},',')
            }
            else{
                this.remainingAmountFormatted = priceFormat(this.odata.currency, this.remainingAmount, ',', 2, 1);
            }
            //this.remainingAmountFormatted = priceFormat(this.odata.currency, this.remainingAmount, ',', 2, 1);
            const pointsBalance = parseFloat(this.payment_credit.price) - parseFloat(this.payment_credit.amount || 0);
            this.rewardsPointBalance = priceFormat(this.odata.currency, pointsBalance, ',', 2, 1);
            this.handleAuthSensitiveChange();
            this.btntxtStatus();
        },
        roundCurrencyAmount(value) {
            const amount = parseFloat(value || 0);
            return Number.isFinite(amount) ? Math.round(amount * 100) / 100 : 0;
        },
        getPaymentCreditCurrency() {
            return this.payment_credit?.currency??(this.odata?.currency??'USD');
        },
        checkCountrySelection() {
            //console.log(this.payinfo.country);
            if (isNull(this.payinfo.country)) {
                this.error_fields.push("country");
            }
        },
        closePayFail() {
            this.payFail = false;
            this.payFailMessage = this.defaultPayFailMessage;
        },
        clearVerifyCodeTimer() {
            if (this.verifyCodeTimer) {
                clearInterval(this.verifyCodeTimer);
                this.verifyCodeTimer = null;
            }
        },
        handleAuthSensitiveChange() {
            if (!this.isSignature) return;
            const hasVerifyState = this.verifyCodeCountdown > 0 || this.code !== '' || this.signatured > 0 || this.signFileid > 0;
            if (!this.requiresSignatureAuthorization()) {
                if (hasVerifyState) {
                    this.clearVerifyCodeTimer();
                    this.verifyCodeCountdown = 0;
                    this.verifyCodeBtnText = "Save and Send Code";
                    this.signFileid = 0;
                    this.initCodeEvent();
                }
                return;
            }
            if (!hasVerifyState) return;

            this.clearVerifyCodeTimer();
            this.verifyCodeCountdown = 0;
            this.verifyCodeBtnText = "Save and Send Code";
            this.signFileid = 0;
            this.initCodeEvent();
        },
        openPayFail(rawMsg) {
            const msg = String(rawMsg ?? '').toLowerCase();
            if (msg === 'payment_status_unknown') {
                this.payFailMessage = this.paymentPendingMessage;
            } else if (msg === 'checkout_request_failed') {
                this.payFailMessage = this.checkoutRequestFailMessage;
            } else if (msg === 'reservation_unavailable' || msg.includes('reservation_unavailable')) {
                this.payFailMessage = this.reservationPayFailMessage;
            }
            else
            if (msg === 'error_cart' || msg.includes('error_cart')) {
                this.payFailMessage = this.cartPayFailMessage;
            } else if (msg === 'paypal_error') {
                this.payFailMessage = this.paypalPayFailMessage;
            } else if (msg.startsWith('card payments in ') || msg.startsWith('please verify the authorization code')) {
                // Actionable backend messages (unsupported Moneris currency, unverified code):
                // show them as-is instead of the generic "card declined" text.
                this.payFailMessage = String(rawMsg);
            } else {
                this.payFailMessage = this.defaultPayFailMessage;
            }
            this.payFail = true;
        },
        openPaymentPending() {
            this.paymentPending = true;
            this.gatewayopen = false;
            this.btntxt.status = 0;
            this.btntxt.txt = 'Payment status pending';
            this.openPayFail('payment_status_unknown');
        },
        async closeReservation() {
            let odata = await localDriver.getItem(this.odkey) || 0;
            window.location = "/details?id=" + odata.product_id;
        },
        codeDescInit() {
            this.codeDesc = "We've sent you a text message. Please enter the code below.";
        },
        mark(p) {
            this.ismark = p.signPad
            this.canvasObj = p.canvas
            this.handleAuthSensitiveChange();
        },
        notEmpty(obj) {
            return notEmpty(obj)
        },
        btntxtStatus() {
            document.querySelectorAll('.redborder').forEach((element) => {
                element.classList.remove('redborder')
            }); 
            if (this.paymentPending) {
                this.btntxt.status = 0;
                return;
            }
            this.btntxt.status = (this.checkedTerm && this.checkedFlightTerm && (0 == this.isSignature || this.signatured>0 || this.paypalAmount<=0) &&  this.payment_method_valid())?1:0
        },
        payoutValidation(options = {}) {
            const ignoreModels = new Set(
                Array.isArray(options?.ignoreModels) ? options.ignoreModels : []
            );
            let redborderElem = [];
            document.querySelectorAll('.redborder').forEach((element) => {
                element.classList.remove('redborder')
            });

            document.querySelectorAll('.required').forEach((element, redborderidx) => {
                let dataModel = element.getAttribute('data-model');
                let dmarr = dataModel ? dataModel.split('.') : [];
                let parentval = element.getAttribute('data-parent');
                let pobj = (parentval == 0 ? element : (parentval == 1 ? element.parentElement : element.parentElement.parentElement));
                //  console.log("--- payoutValidation---", [this, dataModel, dmarr, parentval]);
                if (dataModel) {
                    if (ignoreModels.has(dataModel)) {
                        return;
                    }
                    if ((dmarr.length == 1 && ((!notEmpty(this[dataModel])) || (this[dataModel] == '' || this[dataModel] == 0)))
                        || (dmarr.length == 2 && ((!notEmpty(this[dmarr[0]][dmarr[1]])) || this[dmarr[0]][dmarr[1]] == ''))
                        || (dmarr.length == 3 && ((!notEmpty(this[dmarr[0]][dmarr[1]][dmarr[2]])) || '' == this[dmarr[0]][dmarr[1]][dmarr[2]] || 0 == this[dmarr[0]][dmarr[1]][dmarr[2]]))) {
                        pobj.classList.add('redborder');
                        redborderElem.push(redborderidx);
                        if (this.haslog) {
                            console.log('----------valid no:---------', dataModel);
                        }
                    }
                    else {
                        let errInx = this.moreValidation(dataModel)
                        if (errInx > 0) {
                            redborderElem.push(errInx);
                        }
                    }
                }
            });
            if (document.querySelectorAll('.redborder').length > 0) {
                let intervalId = setTimeout(function () {
                    const firstInvalid = document.querySelector('.redborder');
                    if (firstInvalid?.parentElement) {
                        scrollWindow(firstInvalid.parentElement);
                    }
                }, 500);
            }
            return redborderElem;
        },
        moreValidation(elementName) {
            if ('payinfo.number' === elementName) {
                let _number = this.payinfo.number.replace(/\s+/g, '');
                if (this.payinfo.type == 'AMEX' && !(_number.length == 16 || _number.length == 15)) {
                    document.getElementById("number")?.classList.add('redborder')
                    return 30
                }
                else if (this.payinfo.type != 'AMEX' && this.payinfo.type != '' && _number.length != 16) {
                    document.getElementById("number")?.classList.add('redborder')
                    return 31
                }
            }
            else if ('payinfo.type' === elementName) {
                if (this.payinfo.type === 'AMEX') {
                    if (!this.payinfo.cvccvv || this.payinfo.cvccvv?.toString().length != 4) {
                        document.getElementById("cvccvv")?.classList.add('redborder')
                        return 32
                    }
                }
                else {
                    if (!this.payinfo.cvccvv || this.payinfo.cvccvv?.toString().length != 3) {
                        document.getElementById("cvccvv")?.classList.add('redborder')
                        return 33
                    }
                }
            }
            else if ('payinfo.date' === elementName) {
                if (this.payinfo.date === "") {
                    document.getElementById("expiredate")?.classList.add('redborder')
                    return 34
                }
                else {
                    const inputDate = parseInt(this.payinfo.date.replace('-', ''))
                    const currentDate = new Date()
                    const currentYearMonth = currentDate.getFullYear() * 100 + (currentDate.getMonth() + 1)
                    if (inputDate < currentYearMonth) {
                        document.getElementById("expiredate")?.classList.add('redborder')
                        return 35
                    }
                }
            }
            return 0
        },
        async getCurpayment() {
            document.querySelectorAll('.redborder').forEach((element) => {
                element.classList.remove('redborder')
            });
            let odata = await localDriver.getItem(this.odkey) || {};
            let amtStr = '';
            if(this.insuranceStore.unPay>0 && this.insuranceStore.unPay!=this.insuranceStore.unPayDisplay){
                let amt = await this.checkPayment(1)
                amtStr = pagePriceFormat({currency:this.currencyStore.currentCurrency,amount:amt-this.insuranceStore.unPayDisplay},{currency:'USD',amount:this.insuranceStore.unPay},',\n')
            }
            else{
                amtStr = await this.checkPayment(99)
            }             
            if ('pp_pro' == this.payment_method) {
                this.btntxt.cls = 'pp_pro';
                this.btntxt.img = '/images/footer/paypal.png';

                this.btntxt.txt = amtStr;
            }
            else {
                delete this.btntxt.img;
                delete this.btntxt.cls;
                this.btntxt.txt = 'Today You Pay ' + amtStr;
            }
            // Update remaining amount
            await this.updateRemainingAmount();
        },
        getCounties() {
            if (!notEmpty(this.countries)) {
                new Request().webPost(
                    {},
                    res => {
                        ////console.log("---country---", res);
                        this.countries = res.success ? res.data : [];
                    },
                    "product/product_trip/getCountries",
                    (err) => { },
                    3000,
                    3
                );
            }
        },
        getProvincies(country_id) {
            if (country_id > 0) {
                if (
                    !notEmpty(this.provincies) ||
                    !(country_id in this.provincies)
                ) {
                    new Request().webPost(
                        {
                            country_id: country_id
                        },
                        res => {
                            //console.log("---Provincies---", res);
                            this.curprovincies = res.success ? res.data : [];
                            this.provincies[country_id] = this.curprovincies;
                            //console.log(this.provincies);
                        },
                        "product/product_trip/getProvincies"
                    );
                } else {
                    this.curprovincies = this.provincies[country_id];
                }
            }
        },
        zerotype(item) {
            //console.log('zero=====>', this.payment_type, this.payment_types);
            var res = (item.code != 'free_checkout')
            if (res) {
                for (var i in this.payment_types) {
                    if (this.payment_type == this.payment_types[i].title && this.payment_types[i].amount <= 0.002) {
                        res = false;
                        break;
                    }
                }
            } else {
                for (var i in this.payment_types) {
                    if (this.payment_type == this.payment_types[i].title && this.payment_types[i].amount <= 0.002) {
                        res = true;
                        break;
                    }
                }
            }
            return res;
        },
        async checkPayment(t) {
            //todo: 1=t return amout; 99=t, return format_amount;
            let payment_amt = 0;
            let odata = await localDriver.getItem(this.odkey) || {};
            let cur = odata.currency;
            for (var i in this.payment_types) {
                cur = this.payment_types[i].currency;
                if (this.payment_types[i].title.toLowerCase() === this.payment_type.toLowerCase()) {
                    payment_amt = parseFloat(this.payment_types[i].amount);
                    break;
                }
            }
            //console.log('--------payment_credit7878--111-----',[payment_amt,this.payment_method,this.payment_type,this.payment_credit]);
            if (t == 201) {
                payment_amt -= (['Payment_Transfer', 'free_checkout'].includes(this.payment_method) && notEmpty(this.payment_credit.amount)) ? parseFloat(this.payment_credit
                    .amount) : 0;
            } else {
                payment_amt -= notEmpty(this.payment_credit.amount) ? parseFloat(this.payment_credit.amount) : 0;
            }
            if (payment_amt <= 0.01) {
                // Nothing left to pay: Payment_Transfer when TTG Coins were applied, else free_checkout.
                const targetMethod = this.zeroAmountMethodCode();
                if (this.payment_method != targetMethod) {
                    for (let i in this.payment_methods) {
                        if (targetMethod == this.payment_methods[i].code) {
                            this.payment_method = this.payment_methods[i].code;
                            break;
                        }
                    }
                }
            }
            else if (payment_amt > 0 && (this.payment_method == 'free_checkout' || (this.payment_method == 'Payment_Transfer' && parseFloat(this.payment_credit?.amount || 0) > 0))) {
                const firstVisible = this.firstVisiblePaymentMethodCode()
                if (firstVisible) {
                    this.payment_method = firstVisible
                }
            }
            var res = (1 == (t % 100)) ? payment_amt : (99 == t ? (payment_amt >= 0 ? priceFormat(cur,
                payment_amt,
                ',', 2, 1) : '') : payment_amt);
            // if(this.haslog && 1==t)
            // {
            //     console.log('---payment_amt---'+res);
            // }    
            return res;
        },
        async getValidMethod() {
            var methods = [];
            var cur_amt = await this.checkPayment(98);
            var creditExist = (this.payment_credit && this.payment_credit.price > 0);

            // PayPal Checkout restrictions:
            // - Available for both deposit and full payment: each payment is an independent
            //   PayPal Order, so Pay Later can be applied separately to each payment amount
            // - Not available when order contains insurance (requires raw card forwarding to insurer API)
            // - Not available when order contains flight fees (requires raw card forwarding to ticketing agent)
            //   Covers all flight types: standard (price>0), TBA (price=0, to-be-announced),
            //   AOI (air-only-included), etc. — any non-empty flightOffer means card must be
            //   forwarded to ticketing agent, so PayPal Checkout is not applicable.
            const hasInsurance = this.insuranceStore.needPurchase();
            const hasFlight    = notEmpty(this.odata.flightOffer);
            const excludePaypalCheckout = hasInsurance || (hasFlight && this.FlightExcludePPC);

            for (var i in this.all_methods) {
                this.all_methods[i].zerotype = this.zerotype(this.all_methods[i]);
                if (this.all_methods[i].code === 'pp_pro') {
                    const typeList = Array.isArray(this.all_methods[i].type) ? this.all_methods[i].type : [];
                    if (!typeList.some((type) => type.code === 'AMEX')) {
                        this.all_methods[i].type = [
                            ...typeList,
                            { title: 'American Express', code: 'AMEX' }
                        ];
                    }
                }

                if (this.all_methods[i].code === 'paypal_checkout' && excludePaypalCheckout) {
                    continue;
                }

                if (cur_amt > 0) {
                    if ('free_checkout' != this.all_methods[i].code) {
                        methods.push(this.all_methods[i]);
                    }
                } else if (['free_checkout', 'Payment_Transfer'].includes(this.all_methods[i].code)) {
                    // Zero amount: keep both; validPaymentMethod() shows the one zeroAmountMethodCode() picks.
                    methods.push(this.all_methods[i]);
                } else {
                    if (!creditExist) {
                        methods.push(this.all_methods[i]);
                    }
                }
                //console.log('====methods====',[creditExist,this.all_methods,cur_amt,methods])
            }

            if (this.hasApiFlight() && methods.some(method => method.code === 'eselectplus_api')) {
                // Scenario a: API flight (FP- packages included): Moneris is the only card option; free_checkout stays for a
                // zero amount (validPaymentMethod() shows it only when paypalAmount is 0).
                methods = methods.filter(method => ['eselectplus_api', 'free_checkout'].includes(method.code));
            } else if (this.ppProHideEselectPlus && !this.preferMoneris && methods.some(method => method.code === 'pp_pro')) {
                // Scenario b: when both card gateways are offered, PayPal Pro replaces Moneris.
                methods = methods.filter(method => method.code !== 'eselectplus_api');
            }

            // Multiple gateways: lower sort_order wins (first in dropdown, default selection).
            this.payment_methods = sortPaymentMethods(methods);
            // validPaymentMethod() reads paypalAmount, which the payment_method watcher only
            // refreshes after a method is picked; sync it first or nothing is visible yet and
            // the fallback below picks a hidden code such as Payment_Transfer.
            this.paypalAmount = cur_amt;
            // Default to the first method the dropdown actually shows, so the select never
            // holds a hidden code (e.g. Payment_Transfer) that it would display raw.
            this.payment_method = this.firstVisiblePaymentMethodCode()
                || (this.payment_methods.length > 0 ? this.payment_methods[0].code : '');
            // Prefer Moneris (backend setting) as the default when it is shown; the customer can still pick another method.
            if (this.preferMoneris && this.payment_methods.some(item => item.code === 'eselectplus_api' && this.validPaymentMethod(item))) {
                this.payment_method = 'eselectplus_api';
            }
            // if(this.haslog)
            // {
            //     console.log('-----methods----', [this.all_methods, this.payment_methods]);
            // }
        },
        payment_method_valid() {
            let valid_field = [];
            let res = true;
 			if (this.isZeroAmountCheckout()) {
                return true;
            }
            if (this.isSignature>0 && this.paypalAmount>0) {
                valid_field = ['name', 'type', 'date', 'number', 'cvccvv', 'address', 'country', 'city', 'province', 'postal'];
            }
            else {
                if ('free_checkout' == this.payment_method) {
                    valid_field = [];
                }
                else if ('eselectplus_api' == this.payment_method || 'pp_pro' == this.payment_method) {
                    valid_field = ['name', 'type', 'date', 'number', 'cvccvv'];
                }
                else if ('stripe' == this.payment_method) {
                    // Stripe card fields are validated by Stripe Elements; only check billing fields
                    valid_field = ['address', 'country', 'city', 'province', 'postal'];
                }
            }
            let cpinfo = this.payinfo;
            if (valid_field.length > 0) {
                valid_field.forEach(elem => {
                    if (cpinfo[elem] == undefined || cpinfo[elem] === '') {
                        //console.log('----elem---', [elem, cpinfo]);
                        res = false; return 1;
                    }
                });
            }
            return res;
        },

        async initStripeIfNeeded() {
            this.paypalAmount = await this.checkPayment(1);
            await this.mountStripeElements();
        },
        // Mount the Stripe card fields into the current #card-* containers. The containers live under
        // v-if="payment_method === 'stripe'", and the method is often set by code (default pick, TTG Coins
        // changing the amount), which never fires the dropdown's @change: so this runs from the
        // payment_method / public_key watchers as well. A fresh set of elements is mounted every time because
        // the containers are new DOM nodes after the method was switched away and back.
        async mountStripeElements() {
            if (this.payment_method !== 'stripe' || !this.public_key) return;
            if (this.stripeMounting) return this.stripeMounting;
            this.stripeMounting = (async () => {
                try {
                    if (!this.stripe) {
                        this.stripe = await loadStripe(this.public_key);
                    }
                    if (!this.stripe) return;
                    await this.$nextTick();
                    // The containers appear after the render that follows the method change: wait briefly for them.
                    for (let i = 0; i < 20 && this.payment_method === 'stripe' && !document.querySelector('#card-number'); i++) {
                        await new Promise((resolve) => setTimeout(resolve, 50));
                    }
                    if (this.payment_method !== 'stripe' || !document.querySelector('#card-number')) return;
                    const style = {
                        base: {
                            color: '#2d3748',
                            fontSize: '16px',
                            fontFamily: 'Roboto, sans-serif',
                            '::placeholder': { color: '#a0aec0' }
                        },
                        invalid: { color: '#e53e3e', iconColor: '#e53e3e' }
                    };
                    const elements = this.stripe.elements();
                    const fields = [
                        ['cardNumber', '#card-number'],
                        ['cardExpiry', '#card-expiry'],
                        ['cardCvc', '#card-cvc']
                    ];
                    for (const [name, selector] of fields) {
                        const old = this.cardElement[name];
                        if (old) {
                            try { old.destroy(); } catch (e) { /* already gone with its container */ }
                        }
                        this.cardElement[name] = elements.create(name, { style });
                        this.cardElement[name].mount(selector);
                    }
                } finally {
                    this.stripeMounting = null;
                }
            })();
            return this.stripeMounting;
        },
        refreshDiscountPrice() {
            if (this.customer_id > 0) {
                this.refidx++;
            }
        },
        async initPayment() {
            await this.initFlightOffer()
            await this.getOrderRoomprice()
            await this.couponInit()
            let pd = {}
            let odata = await localDriver.getItem(this.odkey) || {};
            if(odata?.mystery_order_id??false){
                pd = {mystery_order_id:odata.mystery_order_id} 
            }
            await this.paymentGate(pd)
        },
        async initFlightOffer() {
            let odata = await localDriver.getItem(this.odkey) || {};
            if ('flightOffer' in odata) {
                this.offerSelected = odata.flightOffer.id;
                this.respond_id = odata.flightOffer.rid;
                this.flightOffer = odata.flightOffer;
            }
        },
        async customerRefresh() {
            this.customerInfo = await localDriver.getItem('customerInfo') || { customer_id: 0, customer_name: '', avater: '', };
            this.refidx++;
            //console.log('----payement:customer refresh--------------',this.customerInfo);
        },
        async refreshStep(p) {
            this.step = p.step;
            if (p.step == 99) {
                await this.toPayout();
            }
        },
        //shenzhan ban        
        toggleCreditDropdown() {
            //console.log(this.credits);
            if (this.credits) {
                this.showDropdown = !this.showDropdown;
                //this.$refs.popCredit.doToggle();   ///??????????
            }
        },
        onVoucherFocus() {
            if (this.discounts.coupon == '' && this.mystery_coupon!='') {
                this.voucher = this.mystery_coupon;
            }
        },
        async couponInit() {
            var order_data_obj = await localDriver.getItem(this.odkey)
            this.discounts = order_data_obj.discounts
                ? order_data_obj.discounts
                : this.discounts;
        },
        async applyCoupon(t = 0){
            let idx = (++this.applyCouponIdx)
            let appCodes = this.appliedGrouponCodes;
            if (t > 0) {
                this.discounts.coupon = '' + this.voucher.replace(/\t/g, '');
                this.voucher = '';
            }
            if(t==2){
                appCodes = (this.odata.groupon_codes || [])
                    .map((item) => item?.voucher_code || item?.code || '')
                    .filter((item) => item)
            }            
            if (appCodes.length > 0 || this.discounts.coupon || this.discounts.credit?.length > 0) 
            {
                var pd = {
                    coupon: (this.discounts.coupon || '').trim(),
                    groupons:appCodes,
                    credit: this.discounts.credit ? this.discounts.credit.join(",") : "",
                    token: this.orderStore.token,
                    type:t,
                };
                this.couponErr = '';
                if (pd.coupon != '' || pd.credit != '') {
                    this.payment_credit.amount = 0;
                }
                this.couponApplying = true;
                return new Request().webPost(
                    pd,
                    async (res) => {
                        if (!res.success) {
                            this.appliedGrouponCodes = [];
                            this.couponErr = res.error;
                            this.discounts.coupon = '';
                        }
                        else{
                            this.appliedGrouponCodes = appCodes; 
                        }
                        await this.paymentGate({idx:idx});
                    },
                    "checkout/coupon/coupon",
                    () => { this.couponApplying = false; }
                );
            } else {
                this.couponErr = '';
                this.payment_credit.amount = 0;
                return new Request().webPost(
                    {token:this.orderStore.token},
                    async (res) => {
                        await this.paymentGate({idx:idx});
                    },
                    "checkout/coupon/clear"
                );
            }
        },
        //todo: same with other page : right side
        async getOrderRoomprice() {
            this.roomlist = await localDriver.getItem(this.rmkey) || [];
            this.order_data_list =
                await localDriver.getItem(this.odkey) || {};
            //console.log("---payment page---", this.order_data_list);

            this.flightshow = this.order_data_list.flightshow || false;
            this.dCity = this.order_data_list.isFlight ? (this.order_data_list.selectedCity.spot || "") : "";
            this.rCity =
                this.order_data_list.alldays &&
                    this.order_data_list.alldays.length - 1 >= 0
                    ? this.order_data_list.alldays[
                        this.order_data_list.alldays.length - 1
                    ].cityname
                    : "";
            for (var i in this.roomlist) {
                for (var j in this.roomlist[i].Adultslist) {
                    var p = this.roomlist[i].Adultslist[j];
                    p["roomno"] = i + 1;
                    this.alltraveler.push(p);
                }
                for (var j in this.roomlist[i].Childlist) {
                    var p = this.roomlist[i].Childlist[j];
                    p["roomno"] = i + 1;
                    this.alltraveler.push(this.roomlist[i].Childlist[j]);
                }
            }
        },
        getProductOption() {
            new Request().webPost(
                {
                    product_id: this.order_data_list.product_id,
                    depart_date: this.order_data_list.depart_date
                },
                res => {
                    this.options = res.options;
                    for (var i in this.options) {
                        if (this.options[i].product_option_value) {
                            for (var j in this.options[i].product_option_value) {
                                this.options[i].product_option_value[j]["price_format"] = priceFormat(
                                    this.order_data_list.currency,
                                    this.options[i].product_option_value[j].price
                                )
                                if (
                                    this.options[i].product_option_value[j]
                                        .product_option_value_id in this.order_data_list.options
                                ) {
                                    //todo: name need update
                                    this.selectedOptions[this.options[i].product_option_value[j].product_option_value_id] = this.order_data_list.options[
                                        this.options[i].product_option_value[j].product_option_value_id
                                    ];
                                } else {
                                    this.selectedOptions[
                                        this.options[i].product_option_value[
                                            j
                                        ].product_option_value_id
                                    ] = [];
                                }
                            }
                        }
                    }
                    //console.log(this.selectedOptions);
                    this.optionData();
                },
                "account/order/option"
            );
        },
        initMysteryCoupon(d,c){
            if(notEmpty(d.mystery_order_id)){
                this.mystery_coupon = c;
            }            
        },
        async paymentGate(query_data) {
            var d = notEmpty(query_data)
                ? { ...query_data, v: 202003, netprice: parseInt(this.netprice) + 1, token: this.orderStore.token, csyn: 1 }
                : { v: 202003, netprice: parseInt(this.netprice) + 1, token: this.orderStore.token, csyn: 1 };
            if (this.haslog) {
                // console.log('----------gateway---111---', d);
            }
            this.gatewayopen = false;
            
            new Request().webPost(
                d,
                async (res) => {
                    //console.log('=====idx===='+d.idx+'=====>'+this.applyCouponIdx)
                    if(notEmpty(d.idx) && (this.applyCouponIdx > d.idx)){
                        return false
                    }
                    this.couponApplying = false;
                    //console.log('=====idx====continue====')
                    let odata = await localDriver.getItem(this.odkey) || {};
                    if (this.haslog) {
                        //  console.log('----------gateway---res---', res);
                    }
                    if (notEmpty(res.reservation) && res.reservation == 1) {
                        this.reservation = true;
                        //console.log('----------checkout--this.reservation----', this.reservation);
                    }
                    else 
                    {                     
                        this.agentcomm_status = res?.agentcomm_status ?? false;
                        this.text_agree = res.checkout_text_agree ? res.checkout_text_agree : (res.text_agree || "");   //

                        let pattern = /href=[\"|'](.*?)[\"|']/gi;
                        let r = /["|'](.*)["|']/;
                        if (this.text_agree) {
                            let matches = this.text_agree.match(pattern);
                            if (matches && matches.length > 0) {
                                let link = matches[0].match(r);
                                if (link && link[1]) {
                                    this.generalPolicyLink = link[1];
                                }
                            }
                        }

                        this.checkedTerm = "" == this.text_agree;
                        if (res.payment_type) {
                            this.payment_types = res.payment_type;
                        }

                        if (notEmpty(res.coupon)) {
                            let point_arr = [];
                            if (res.coupon.customer_credit) {
                                const customerCredit = Array.isArray(res.coupon.customer_credit)
                                    ? res.coupon.customer_credit
                                    : Object.values(res.coupon.customer_credit);
                                const customerPaymentCredit = Array.isArray(res.coupon.customer_payment_credit)
                                    ? res.coupon.customer_payment_credit
                                    : Object.values(res.coupon.customer_payment_credit || {});
                                this.credits = customerCredit.filter(item => parseInt(item?.type || 0, 10) !== 1);
                                this.coinCredits = customerPaymentCredit.length > 0
                                    ? customerPaymentCredit
                                    : customerCredit.filter(item => parseInt(item?.type || 0, 10) === 1);
                                //console.log('----point_arr--222-',this.credits)
                                for (let itmidx in this.credits) {
                                    point_arr.push(this.credits[itmidx].ctid);
                                }
                            }
                            if (notEmpty(res.coupon.cart_credit)) {
                                this.discounts.credit = [];
                                for (let curpoint of point_arr) {
                                    let allpointid = true;
                                    for (let spoint of (String(curpoint).split(','))) {
                                        if (!(notEmpty(res.coupon.cart_credit[spoint]))) {
                                            allpointid = false;
                                            break;
                                        }
                                    }
                                    if (allpointid) {
                                        this.discounts.credit.push(curpoint);
                                    }
                                }
                            }
                            this.discounts.coupon = res.coupon.coupon;
                            
                        }
                        else {
                            this.discounts.coupon = '';
                        }
                        this.initMysteryCoupon(d,this.discounts.coupon)
                        //  this.credits=[{id:1,name:2}]
                        if(res.groupon?.length>0){
                           this.appliedGrouponCodes = res.groupon;
                        }
                        odata.totals = res.shopping_cart?.totals ?? []
                        odata.agentComm = 0;
                        for (var i in this.payment_types) {
                            if (notEmpty(this.payment_types[i].agentComm)) {
                                odata.agentComm = this.payment_types[i].agentComm;
                            }
                            let curtype = this.payment_types[i].title.toLowerCase();
                            if (this.payment_types.length == 1) {
                                this.payment_type = curtype;
                            }
                            else {
                                // Prefer "Deposit Amount" over "Full Amount" when both are available
                                if (curtype == 'deposit amount') {
                                    this.payment_type = curtype;
                                } else if (this.payment_type == "") {
                                    this.payment_type = curtype;
                                }
                            }

                            if ("Payment Credit" == this.payment_types[i].title) {
                                this.payment_credit = {
                                    price: this.payment_types[i].amount,
                                    price_format: priceFormat(
                                        this.payment_types[i].currency,
                                        this.payment_types[i].amount,
                                        ","
                                    ),
                                    currency: this.payment_types[i].currency || odata.currency || 'USD',
                                    amount: 0,
                                };
                            }
                        }
                        if (notEmpty(odata) && odata.product_id) {
                            await localDriver.setItem(this.odkey, odata);
                        }
                        this.refidx++;

                        if (res.payment_method && res.payment_method.payment_methods) {
                            //console.log('----methods---',res.payment_method.payment_methods)
                            this.all_methods = res.payment_method.payment_methods;
                            this.preferMoneris = !!Number(res.payment_method.prefer_moneris || 0);
                            // Extract PayPal client_id returned by the payment method model
                            // all_methods may be a plain object (keyed by code) or an array — use Object.values to be safe
                            const ppMethod = Object.values(this.all_methods).find(m => m.code === 'paypal_checkout');
                            if (ppMethod) this.paypalClientId = ppMethod.client_id || '';
                            //this.payment_method  = res.payment_method.code;
                            await this.getValidMethod();
                        }
                        if (res.public_key) this.public_key = res.public_key;
                        this.visaAuthLevel = res.visaAuthLevel;
                        this.coinsHidden = parseInt(res.coinsHidden);
                        //console.log('this.visaAuthLevel:', this.visaAuthLevel);
                        await this.getCurpayment();
                        this.paypalAmount = await this.checkPayment(1);
                        //this.checkCreditAmt();
                    }
                    this.gatewayopen = true;
                    this.cart.setCount(this.cart.getCount());
                    this.agentComm = '';
                    if(res?.shopping_cart?.totals??false){
                        for(let t of res.shopping_cart.totals){
                            if(t.code == 'agentcomm'){
                                this.agentComm = t.text;
                                break;
                            }
                        }
                    }

                    //console.log('=====idx====continue===end=======')
                },
                'checkout/checkout&currency=' + (this.odata?.pageCurrency || this.odata?.currency || this.currencyStore.currentCurrency),
                () => { this.couponApplying = false; }
            );
        },

        async changePaymentType(item) {
            this.payment_type = item.title.toLowerCase();
            await this.getValidMethod();
            this.paypalAmount = await this.checkPayment(1);
        },

        getLowerCase(t) {
            return t.toLowerCase();
        },
        async pure_payment(d) {
            //console.log(d);
            this.createPageData(d);
            delete d.pageData;

            if ("checkout/checkout" == d.url) {
                delete d.url;
                await this.paymentGate(d);
            } else {
                //todo:  refund or other
            }
        },
        startListenEvent() {
            const links = this.$refs.termPolicy.getElementsByTagName("a");
            for (const link of links) {
                ////console.log("Link clicked");
                link.addEventListener("click", this.handleLinkClick);
            }
        },
        handleLinkClick(event) {
            // Prevent default navigation to the link URL
            event.preventDefault();
            fetch(event.currentTarget.href)
                .then(response => response.text())
                .then(linkContent => {
                    this.termContent = linkContent;
                    this.dialogVisible = true;
                })
                .catch(error => {
                    //console.error("Error:", error);
                });
        },
        termConfirm(p) {
            this.checkedTerm = p.checkedTerm;
            this.dialogVisible = p.dialogVisible;
        },

        numberKeypress() {
            var number = this.payinfo.number.replace(/\s/g, '');
            if (!(/^[1-9][0-9\s]{0,21}$/.test(number))) {
                number = number.slice(0, number.length - 1);
            }
            this.payinfo.number = number.substring(0, 16).replace(/(\d{4})(?=\d)/g, "$1 ");
        },
        cvcKeypress() {
            if (!(/^[0-9][0-9\s]{0,3}$/.test(this.payinfo.cvccvv))) {
                this.payinfo.cvccvv = this.payinfo.cvccvv ? this.payinfo.cvccvv.slice(0, this.payinfo.cvccvv.length - 1) : '';
            }
        },
        closeSignWin() {
            this.signWindow = false;
            this.signidx++;
        },
        printMe() { // Print event

        },
        isValidSignature(signaturePad) {
            if (!signaturePad || typeof signaturePad.toData !== 'function') {
                return false;
            }
            if (signaturePad.isEmpty()) {
                return false;
            }
            const data = signaturePad.toData();
            let totalLength = 0;
            let directionChanges = 0
            let lastAngle = null
            data.forEach(stroke => {
                let points = stroke.points
                for (let i = 1; i < points.length; i++) {
                    const dx = points[i].x - points[i - 1].x;
                    const dy = points[i].y - points[i - 1].y;
                    totalLength += Math.sqrt(dx * dx + dy * dy);

                    const angle = Math.atan2(dy, dx);
                    if (lastAngle !== null) {
                        const delta = Math.abs(angle - lastAngle);
                        if (delta > 0.3) {
                            directionChanges++;
                        }
                    }
                    lastAngle = angle;
                }
            });
            if (totalLength < 100) {
                return false;
            }
            else if (directionChanges < 2) {
                return false;
            }
            return true
        },
        savePDF() {
            if (this.verifyCodeLoading || (this.verifyCodeCountdown > 0)) {
                return;
            }
            this.verifyCodeLoading = true

            // Move required checks from "Today You Pay" to "Save and Send Code":
            // validate payment inputs/terms before generating and sending verification code.
            const requiredErrors = this.payoutValidation({
                ignoreModels: ['code', 'signatured']
            });
            const needFlightTerm = this.flight_agree !== '';
            const needGeneralTerm = this.generalPolicyLink !== '';
            const preRequiredReady =
                (!needGeneralTerm || this.checkedTerm) &&
                (!needFlightTerm || this.checkedFlightTerm) &&
                this.payment_method_valid();
            if (requiredErrors.length > 0 || !preRequiredReady) {
                this.verifyCodeLoading = false;
                return false;
            }

            if (!this.isValidSignature(this.ismark)) {
                this.signWindow = true;
                this.verifyCodeLoading = false;
                return false;
            }

            this.initCodeEvent();

            let cardNumber = this.payinfo.number;
            let cvcNumber = this.payinfo.cvccvv;
            let cardType = notEmpty(this.payinfo.type) ? this.payinfo.type.toUpperCase() : '';

            if (cardNumber && (cardNumber.length >= 19 || ('AMEX' == cardType && cardNumber.length >= 18))) {
                const element = document.getElementById('leftpage');

                html2canvas(element, {
                    scale: 1,
                    useCORS: true,
                    onclone: (clonedDocument) => {
                        exposeAuthorizationPdfFormValues(
                            element,
                            clonedDocument.getElementById('leftpage')
                        );
                    }
                }).then((canvas) => {
                    const imgData = canvas.toDataURL('image/jpeg', 0.8);
                    const pdf = new jsPDF({
                        unit: 'mm',
                        format: 'a5',
                        orientation: 'portrait'
                    });

                    const pdfWidth = pdf.internal.pageSize.getWidth();
                    const pdfHeight = pdf.internal.pageSize.getHeight();

                    const imgProps = pdf.getImageProperties(imgData);
                    const imgWidth = pdfWidth;
                    const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

                    let heightLeft = imgHeight;
                    let position = 0;

                    // Add the first page
                    pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
                    heightLeft -= pdfHeight;

                    // Continue adding pages when content exceeds one page
                    while (heightLeft > 0) {
                        position -= pdfHeight;
                        pdf.addPage();
                        pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
                        heightLeft -= pdfHeight;
                    }

                    const pdfDataUri = pdf.output('datauristring');
                    this.pagelog(new Request(), 'pdfReq', { pdflen:pdfDataUri.length});
                    new Request().webPost({
                        id: this.customer_id,
                        uploaddir: 'visaauthorization',
                        file: pdfDataUri
                    },
                        (res) => {
                            this.clearVerifyCodeTimer();
                            this.verifyCodeCountdown = 60;
                            this.verifyCodeBtnText = this.verifyCodeCountdown.toString()
                            this.verifyCodeTimer = setInterval(() => {
                                this.verifyCodeCountdown--;
                                if (0 == this.verifyCodeCountdown) {
                                    this.clearVerifyCodeTimer();
                                    this.verifyCodeBtnText = "Save and Send Code";
                                }
                                else {
                                    this.verifyCodeBtnText = this.verifyCodeCountdown.toString();
                                }
                            }, 1000);
                            if (res.success && res.data.id > 0) {
                                this.signFileid = res.data.id;
                                if (this.visaAuthLevel > 0) {
                                    this.sendCode(this.signFileid);
                                } else {
                                    this.signatured = 1;
                                    this.btntxtStatus();
                                }
                            }
                        },
                        'tool/upload/html2pdf'
                    )
                        .finally(() => {
                            this.verifyCodeLoading = false
                        });
                    this.payinfo.number = cardNumber;
                    this.payinfo.cvccvv = cvcNumber;
                });
            }
            else {
                this.pagelog(new Request(), 'invalidCard', { cardLast4: cardNumber.replace(/\D/g, '').slice(-4) });
                this.verifyCodeLoading = false;
            }
        },
        initCodeEvent() {
            this.code = '';
            this.signatured = 0;
            this.codeDescInit();
        },
        sendCode(id) {
            let maintraveler = this.roomlist?.[0]?.Adultslist?.[0] || {};
            var d = {
                id: id > 0 ? id : this.signFileid,
                phone: (maintraveler.phoneZone || '+1') + maintraveler.Phone, ///this.roomlist[0].Adultslist[0].Phone,
                type: this.sendCodeType,
            };
            this.sendCodeWindow = '';
            this.initCodeEvent();
            new Request().webPost(
                d,
                (res) => {
                    //console.log(res);
                    let er = true;
                    if (res.success) {
                        //alert('A code has been sent to your email '+(this.sendCodeType>1?'and cellphone':'')+'.');
                        this.sendCodeWindow = this.sendCodeType == 1 ? this.customerInfo.email : maintraveler.Phone.slice(-4);
                        this.codeDesc = (this.sendCodeType == 1 ? 'We sent a verification code to [' + this.sendCodeWindow + ']. Please check your inbox and enter the code below.' :
                            'A text message with a verification code has been sent to your phone number ending in ******' + this.sendCodeWindow);
                        // The code itself is no longer returned (verified server-side); `code` only
                        // marks that one was sent so the code input is shown.
                        this.code = 'sent';
                        er = false;
                    }
                    if(er){
                        this.pagelog(new Request(), 'sendCodeErr', {});
                    }
                },
                'account/account/sendCode',
                (err) => {
                    this.pagelog(new Request(), 'sendCodeErr', {msg: err?.message || 'Unknown error'});
                }
            );
        },
        signDoneEvent(param) {
            //console.log('verified afer====');
            var t = this.signatured;
            //console.log('------>>>> signDoneEvent', [t, param]);
            this.signatured = param;
        },
        checkPageTotal_GatewayTotal() {
            var res = true;
            var errinfo = [];
            if (this.order_data_list) {
                for (var i in this.payment_types) {
                    if (this.payment_types[i].title.toLowerCase() === "full amount") {
                        res = this.payment_types[i].amount == priceAmount(this.order_data_list.Total);
                        errinfo = {
                            gateTotal: this.payment_types[i].amount,
                            orderinfo: this.order_data_list
                        };
                        break;
                    }
                }
            }
            if (!res && errinfo) {
                new Request().webPost(errinfo, res => { }, "checkout/checkout/totalError");
            }
            return res;
        },
        async pp_standard_req(oid, pid, odata) {
            const apiURL = window.location.origin.replace('www', 'data').replace('test', 'test_data');
            let paypalEmail = '';
            let url = 'https://www.paypal.com/cgi-bin/webscr';
            for (let i in this.payment_methods) {
                if (this.payment_methods[i].payment_code == 'pp_standard') {
                    paypalEmail = this.payment_methods[i].email;
                    if (this.payment_methods[i].test > 0) {
                        url = 'https://www.sandbox.paypal.com/cgi-bin/webscr';
                    }
                }
            }
            if (paypalEmail != '') {
                let pdata =
                {
                    cmd: '_cart',
                    upload: 1,
                    business: paypalEmail,
                    item_name_1: odata.tripname,
                    item_number_1: 'model 1',
                    amount_1: await this.checkPayment(1),
                    quantity_1: 1,
                    weight_1: 0,
                    currency_code: this.paymentChargeCurrency(),
                    charset: 'utf-8',
                    return: apiURL + '/index.php?route=payment/pp_standard/success&custom=' + oid + '_' + pid,
                    notify_url: apiURL + '/index.php?route=payment/pp_standard/notify&custom=' + oid + '_' + pid,
                    cancel_return: apiURL + '/index.php?route=payment/pp_standard/cancel&custom=' + oid + '_' + pid,
                    paymentaction: 'authorization',
                    custom: 10,
                    bn: 'OpenCart_2.0_WPS'
                }
                //console.log('===========VITE_DATA_URL==================',[pdata])
                jsPost(url, pdata);
            }
        },
        async completeStripeReturn(paymentIntentId) {
            const completion = await new Promise((resolve) => {
                new Request().webPost(
                    { paymentIntentId },
                    (res) => resolve(res),
                    'payment/stripe/stripePaymentComplete',
                    () => resolve(null)
                );
            });
            if (!completion?.success || !completion.order_id) {
                const stripeStatus = completion?.data?.status;
                if (this.odata && ['requires_payment_method', 'canceled'].includes(stripeStatus)) {
                    const url = new URL(window.location.href);
                    url.searchParams.delete('intentId');
                    window.history.replaceState(window.history.state, '', url.toString());
                    this.paymentPending = false;
                    this.gatewayopen = true;
                    this.btntxt.txt = 'Continue';
                    this.btntxtStatus();
                    this.payFailMessage = this.paymentNotCompletedMessage;
                    this.payFail = true;
                    try { sessionStorage.removeItem('ttgStripePaymentMethodId'); } catch (e) { /* Storage is optional. */ }
                    return;
                }
                this.openPaymentPending();
                return;
            }

            const url = new URL(window.location.href);
            url.searchParams.delete('intentId');
            window.history.replaceState(window.history.state, '', url.toString());
            const newoid = parseInt(completion.order_id, 10);
            this.paymentPending = false;
            this.payFail = false;
            this.gatewayopen = false;
            this.btntxt.status = 0;
            this.btntxt.txt = 'Done';
            this.newoid = newoid;
            this.showPaySucc = true;

            try {
                await localDriver.removeItem(this.odkey);
                await localDriver.removeItem('travelers');
                localStorage.removeItem('atracking');
            } catch (e) { /* Best-effort checkout cache cleanup. */ }

            const paymentToken = (() => {
                try { return sessionStorage.getItem('ttgStripePaymentMethodId') || ''; } catch (e) { return ''; }
            })();
            try { sessionStorage.removeItem('ttgStripePaymentMethodId'); } catch (e) { /* Storage is optional. */ }
            if (this.odata && this.insuranceStore.needPurchase()) {
                try {
                    const countryCode = this.payinfo?.country
                        ? (this.countries.find(c => c.country_id == this.payinfo.country)?.iso_code_2 || '')
                        : '';
                    const address = formatAddress(
                        countryCode,
                        this.payinfo?.province || '',
                        this.payinfo?.city || '',
                        this.payinfo?.address || '',
                        this.payinfo?.postal || ''
                    );
                    await this.insuranceStore.purchase(newoid, address, { paymentToken });
                } catch (error) {
                    this.pagelog(new Request(), 'stripeInsurancePurchaseErr', { order_id: newoid, msg: error?.message || 'insurance_purchase_failed' });
                }
            }
            try {
                this.GoogleTrack(newoid, await this.checkPayment(98), this.odata?.currency);
                const specialRequest = await localDriver.getItem('special_request') || '';
                if (specialRequest) await this.sendMsg(newoid, specialRequest);
            } catch (error) {
                this.pagelog(new Request(), 'stripeReturnFollowupErr', { order_id: newoid, msg: error?.message || 'followup_failed' });
            }
        },
        // Returns: 1=completed, 0=definite failure, 2=3DS redirect, 3=payment status unknown
        async payWithStripe(data) {
            if (!this.stripe) return {status:0};
            let countryCode = '';
            if (this.payinfo?.country) {
                const match = this.countries.find(c => c.country_id == this.payinfo.country);
                countryCode = match?.iso_code_2 || '';
            }
            const billing_details = {
                name: this.payinfo?.name ?? '',
                address: {
                    line1: this.payinfo?.address ?? '',
                    city: this.payinfo?.city ?? '',
                    state: this.payinfo?.province ?? '',
                    postal_code: this.payinfo?.postal ?? '',
                    country: countryCode
                }
            };
            let paymentMethod;
            let paymentMethodError;
            try {
                ({ paymentMethod, error: paymentMethodError } = await this.stripe.createPaymentMethod({
                    type: 'card',
                    card: this.cardElement.cardNumber,
                    billing_details
                }));
            } catch (error) {
                this.pagelog(new Request(), 'stripeErr', { msg: error?.message || 'create_payment_method_failed' });
                return {status:0};
            }
            if (paymentMethodError) {
                this.pagelog(new Request(), 'stripeErr', { payMethod: paymentMethodError.message });
                try { sessionStorage.removeItem('ttgStripePaymentMethodId'); } catch (e) { /* Storage is optional. */ }
                return {status:0};
            }
            try {
                sessionStorage.setItem('ttgStripePaymentMethodId', paymentMethod.id);
            } catch (e) { /* Storage is optional. */ }
            const originUrl = new URL(window.location.href);
            const originUrlParams = originUrl.searchParams;
            originUrlParams.delete('intentId');
            const callback = originUrl.origin + originUrl.pathname + '?' + originUrlParams.toString() + '&intentId=' + data.paymentIntentId;
            let result;
            try {
                result = await this.stripe.confirmCardPayment(data.clientSecret, {
                    payment_method: paymentMethod.id,
                    return_url: callback,
                });
            } catch (error) {
                this.pagelog(new Request(), 'stripePayoutErr', { msg: error?.message || 'payment_status_unknown' });
                return {status:3,paymentToken:paymentMethod.id,paymentIntentId:data.paymentIntentId};
            }
            if (result.error) {
                this.pagelog(new Request(), 'stripePayoutErr', { msg: result.error.message });
                if (['api_connection_error', 'api_error'].includes(result.error.type)) {
                    return {status:3,paymentToken:paymentMethod.id,paymentIntentId:data.paymentIntentId};
                }
                try { sessionStorage.removeItem('ttgStripePaymentMethodId'); } catch (e) { /* Storage is optional. */ }
                return {status:0,paymentToken:paymentMethod.id};
            }
            if (result.paymentIntent?.status === 'succeeded') {
                let completed = false;
                try {
                    completed = await new Promise((resolve) => {
                        new Request().webPost(
                            { paymentIntentId: result.paymentIntent.id },
                            (resStripe) => { resolve(resStripe?.success === true); },
                            'payment/stripe/stripePaymentComplete',
                            () => { resolve(false); }
                        );
                    });
                } catch (error) {
                    this.pagelog(new Request(), 'stripeCompleteErr', { msg: error?.message || 'payment_status_unknown' });
                }
                return completed
                    ? {status:1,paymentToken:paymentMethod.id}
                    : {status:3,paymentToken:paymentMethod.id,paymentIntentId:result.paymentIntent.id};
            }
            if (result.paymentIntent?.status === 'requires_action') {
                return {status:2,paymentToken:paymentMethod.id};
            }
            if (result.paymentIntent?.status === 'processing') {
                return {status:3,paymentToken:paymentMethod.id,paymentIntentId:result.paymentIntent.id};
            }
            if (!result.paymentIntent) {
                return {status:3,paymentToken:paymentMethod.id,paymentIntentId:data.paymentIntentId};
            }
            try { sessionStorage.removeItem('ttgStripePaymentMethodId'); } catch (e) { /* Storage is optional. */ }
            return {status:0,paymentToken:paymentMethod.id};
        },
        // Double-click / repeated tap guard: the button is disabled from the first tap until the payment result
        // is known (or the request times out and the status is checked).
        async toPayout() {
            if (this.paySubmitting) return
            this.paySubmitting = true
            this.payRequestInFlight = false
            this.btntxt.status = 0
            try {
                await this.submitPayout()
            } finally {
                if (!this.payRequestInFlight) this.resetPayButton(this.btntxt.txt)
            }
        },
        resetPayButton(txt) {
            this.paySubmitting = false
            this.payRequestInFlight = false
            if (txt !== undefined) this.btntxt.txt = txt
            this.btntxtStatus()
        },
        // The request did not come back in time: the server may still have created and charged the order.
        // Ask for the result of this checkout (its page token) instead of spinning forever.
        // While another request is still paying this checkout (processing), keep waiting with the button disabled:
        // it is checked again every 3 s for about a minute.
        async recoverPayout(checkoutToken, bt1, attempt = 0) {
            this.payRequestInFlight = false
            new Request().webPost(
                { token: checkoutToken },
                async (res) => {
                    if (res?.success && res.processing && !res.complete && attempt < 20) {
                        setTimeout(() => this.recoverPayout(checkoutToken, bt1, attempt + 1), 3000)
                        return
                    }
                    if (res?.success && res.complete && res.order_id > 0) {
                        await localDriver.removeItem(this.odkey)
                        await localDriver.removeItem('travelers')
                        localStorage.removeItem('atracking')
                        this.newoid = res.order_id
                        this.showPaySucc = true
                        this.btntxt.txt = 'Done'
                        return
                    }
                    this.resetPayButton(bt1)
                    this.openPayFail(
                        res?.order_id > 0
                            ? 'Your order was placed but the payment is not confirmed yet. Please check My Bookings before paying again.'
                            : 'We could not confirm your payment yet. Please check My Bookings before paying again.'
                    )
                },
                'checkout/payment/checkoutStatus',
                () => {
                    this.resetPayButton(bt1)
                    this.openPayFail('checkout_request_failed')
                }
            )
        },
        async submitPayout() {
            if (this.paymentPending) return;
            // PayPal Checkout is handled entirely by the PaypalButton component in the footer
            if (this.payment_method === 'paypal_checkout') return;
            let payoutValidation = this.payoutValidation();
            if (this.gatewayopen && payoutValidation.length === 0) 
            {
                this.pagelog(new Request(), 'passValition');            
                let odata = await localDriver.getItem(this.odkey) || {};
                let countryIsoCode2 = '';
                if (this.payinfo.country) {
                    const match = this.countries.find(c => c.country_id == this.payinfo.country);
                    countryIsoCode2 = match?.iso_code_2 || '';
                }
               
                    let flight = {};
                    if (('flightOffer' in odata) && notEmpty(odata.flightOffer)) {
                        let fprice = parseFloat(odata.cityprice) + parseFloat(odata.flightOffer.price);
                        let flightInfo = odata.flightOffer.info;

                        flight = {
                            base_price: parseFloat(odata.cityprice),
                            info: flightInfo,
                            api_price: odata.flightOffer.api_price,
                            price: parseFloat(odata.cityprice) + parseFloat(odata.flightOffer.price),
                            qty: parseInt(odata.flightOffer.persons),
                            Total: fprice * parseInt(odata.flightOffer.persons),
                            total_format: priceFormat(odata.currency, parseFloat(odata.flightOffer.price) * parseInt(odata.flightOffer.persons)),
                            response_id: odata.flightOffer.rid,
                            offer_id: odata.flightOffer.id,
                            rule_id: (('tripFlightInfo' in odata) ? odata.tripFlightInfo.id : 0),
                            deposit: notEmpty(odata.flightOffer.deposit) ? odata.flightOffer.deposit : 0,
                        }
                    }
                    const selectedCreditIds = this.getSelectedCreditIds();
                    const paymentAmount = Math.max(0, parseFloat(await this.checkPayment(1)) || 0);
                    const insuranceOnlyRemaining = await this.isInsuranceOnlyRemainingPayment();
                    const hasSelectedCredit = selectedCreditIds.length > 0 || this.shouldUseSeparateCredit();
                    const zeroAmountCheckout = paymentAmount <= 0.01;
                    const orderPaymentMethod = zeroAmountCheckout
                        ? this.zeroAmountMethodCode()
                        : insuranceOnlyRemaining
                        ? (hasSelectedCredit ? 'Payment_Transfer' : 'free_checkout')
                        : this.payment_method;
                    const orderPaymentAmount = (zeroAmountCheckout || insuranceOnlyRemaining) ? 0 : paymentAmount;

                    let data = {
                        order_id: this.order_id,
                        payment_id: this.payment_id,
                        product_id: odata.product_id,
                        payment_type: this.payment_type,
                        payment_method: this.payment_method,
                        credit: selectedCreditIds.join(","),
                        cc_owner: [this.payinfo?.name ?? ''],
                        cc_type: [this.payinfo?.type?.toUpperCase() ?? ''],
                        cc_number: [this.payinfo?.number ?? ''],
                        cc_expire_date_month: [this.payinfo?.date?.slice(5, 7) ?? ''],
                        cc_expire_date_year: [this.payinfo?.date?.slice(0, 4) ?? ''],
                        cc_cvc: [this.payinfo?.cvccvv ?? ''],
                        address: this.payinfo?.address ?? '',
                        city: this.payinfo?.city ?? '',
                        country: this.payinfo?.country ?? '',
                        postal: this.payinfo?.postal ?? '',
                        province: this.payinfo?.province ?? '',
                        agree: 1,
                        comment: "",
                        signFileid: this.signFileid,
                        flight: flight,
                        sign_img: this.canvasObj ? this.canvasObj.toDataURL('image/png') : '',
                        netprice: parseInt(this.netprice) + 1,
                        token: this.orderStore.token,
                        Csyn: 1,
                        atracking: localStorage.getItem('atracking') || '',
                        groupon_applied: this.appliedGrouponCodes.length > 0 ? 1 : 0,
                        groupon_order_id: odata.groupon_order_id || 0,
                        groupon_codes: this.appliedGrouponCodes,
                    };


                    if (this.payment_credit.amount > 0) {
                        data['seperateCredit'] = {
                            currency: this.getPaymentCreditCurrency(),
                            amount: this.payment_credit.amount
                        };
                    }
                    let url = this.order_id > 0 ? "checkout/payment/payment" : "checkout/payment";
                    let bt1 = this.btntxt.txt;
                    this.btntxt.txt = 'Process...';
                    this.pagelog(new Request(), 'payout', {
                        url: url,
                        paymentMethod: this.payment_method,
                        orderPaymentMethod: orderPaymentMethod,
                        paymentType: this.payment_type,
                        paymentAmount: paymentAmount,
                        orderPaymentAmount: orderPaymentAmount,
                        zeroAmountCheckout: zeroAmountCheckout,
                        insuranceOnlyRemaining: insuranceOnlyRemaining,
                        credit: data.credit,
                        selectedCredits: selectedCreditIds,
                        paymentCreditAmount: this.payment_credit.amount,
                        shouldUseSeparateCredit: this.shouldUseSeparateCredit(),
                    });

                    // Force a price check (same trip/option/flight check the countdown timer runs)
                    // right before the actual submit. If it changed, bookingPriceSummary shows its
                    // confirm dialog and this awaits the user's response - true only if the user
                    // confirmed and stayed on this step; false means they were redirected away
                    // (declined, or a non-flight price changed), so payment must not proceed.
                    const priceOk = await this.$refs.bookingSummaryRef?.forcePriceCheck() ?? true
                    if (!priceOk) {
                        this.resetPayButton(bt1)
                        return
                    }

                    if (this.payment_method == 'pp_standard') {
                        data['orderback'] = 1;
                        this.payRequestInFlight = true;
                        new Request().webPost(
                            data,
                            async (res) => {
                                let newoid = (notEmpty(res.order_id) ? res.order_id : 0);
                                let newpayment_id = (notEmpty(res.payment_id) ? res.payment_id[0] : 0);
                                if (newoid > 0 && newpayment_id > 0) {
                                    await this.pp_standard_req(newoid, newpayment_id, odata);
                                    let intervalId = setInterval(() => {
                                        new Request().webPost(
                                            { order_id: newoid, payment_id: newpayment_id },
                                            async (res) => {
                                                if (res.success && (200 == res.data.status || 401 == res.data.status)) {
                                                    clearInterval(intervalId);
                                                    if (res.data.status == 200) {
                                                        if (res.success && newoid != undefined && newoid > 0) {
                                                            this.btntxt.txt = 'Done';
                                                            await localDriver.removeItem(this.odkey);
                                                            await localDriver.removeItem('travelers');
                                                            localStorage.removeItem('atracking'); // one-shot: don't re-credit a later unrelated booking
                                                            this.newoid = newoid;
                                                            this.showPaySucc = true;

                                                            const state = this.payinfo.province
                                                            const address = formatAddress(countryIsoCode2, state, this.payinfo.city, this.payinfo.city)

                                                            await this.insuranceStore.purchase(newoid,
                                                                address,
                                                                {
                                                                    cardHolderName: data.cc_owner[0],
                                                                    cardNumber: data.cc_number[0],
                                                                    cvc: data.cc_cvc[0],
                                                                    expirationMonth: data.cc_expire_date_month[0],
                                                                    expirationYear: data.cc_expire_date_year[0]
                                                                })
                                                            this.GoogleTrack(res.order_id, await this.checkPayment(98), odata.currency);
                                                            //add special_content
                                                            var special_request = await localDriver.getItem('special_request') || "";
                                                            //  console.log("special_request",special_request);
                                                            if (special_request) {
                                                                await this.sendMsg(newoid, special_request);
                                                            }
                                                            //  window.location = "/user/bookings/?from=payment&id=" + newoid;
                                                        } else {
                                                            this.resetPayButton(bt1);
                                                            this.openPayFail(res?.msg);
                                                            //alert(JSON.stringify(res));
                                                        }
                                                    }
                                                    else {
                                                        this.resetPayButton(bt1);
                                                        this.openPayFail(res?.msg);
                                                        //alert(JSON.stringify(res));
                                                    }
                                                }
                                            },
                                            'payment/pp_stand/status'
                                        );
                                    }, 5000);
                                }
                            },
                            url
                        );
                    }
                    else {
                        this.payRequestInFlight = true;
                        const settle = { done: false, timedOut: false, timer: null };
                        settle.timer = setTimeout(() => {
                            if (settle.done) return;
                            settle.timedOut = true;
                            this.recoverPayout(data.token, bt1);
                        }, 60000);
                        new Request().webPost(
                            data,
                            async (res) => {
                                if (settle.timedOut) return;
                                settle.done = true;
                                clearTimeout(settle.timer);
                                let newoid = res?.order_id ?? (res?.data?.order_id ?? 0);
                                let stripePaymentConfirmed = false;
                                try {
                                    if (res.success && newoid != undefined && newoid > 0) {
                                        const state = this.payinfo.province;
                                        const address = formatAddress(countryIsoCode2, state, this.payinfo.city, this.payinfo.address, this.payinfo.postal);

                                        if (this.payment_method === 'stripe') {
                                            const stripeResult = await this.payWithStripe(res.data ?? {});
                                            if (stripeResult.status === 0) {
                                                this.resetPayButton(bt1);
                                                this.openPayFail(res?.msg);
                                                return;
                                            }
                                            if (stripeResult.status === 2) return; // Stripe is redirecting to complete 3DS.
                                            if (stripeResult.status === 3) {
                                                this.openPaymentPending();
                                                if (stripeResult.paymentIntentId) {
                                                    const returnUrl = new URL(window.location.href);
                                                    returnUrl.searchParams.set('intentId', stripeResult.paymentIntentId);
                                                    window.history.replaceState(window.history.state, '', returnUrl.toString());
                                                    await this.completeStripeReturn(stripeResult.paymentIntentId);
                                                }
                                                return;
                                            }

                                            stripePaymentConfirmed = true;
                                            this.resetPayButton(bt1);
                                            try { sessionStorage.removeItem('ttgStripePaymentMethodId'); } catch (e) { /* Storage is optional. */ }
                                            await localDriver.removeItem(this.odkey);
                                            await localDriver.removeItem('travelers');
                                            localStorage.removeItem('atracking'); // one-shot: don't re-credit a later unrelated booking
                                            this.newoid = newoid;
                                            this.showPaySucc = true;
                                            try {
                                                const insuranceRes = await this.insuranceStore.purchase(newoid, address, {
                                                    paymentToken: stripeResult.paymentToken ?? '',
                                                });
                                                if (insuranceRes.action ?? false) {
                                                    // Insurance 3DS continuation is handled by the insurance payment flow.
                                                }
                                            } catch (insuranceError) {
                                                this.pagelog(new Request(), 'stripeInsurancePurchaseErr', { order_id: newoid, msg: insuranceError?.message || 'insurance_purchase_failed' });
                                            }
                                        } else {
                                            await localDriver.removeItem(this.odkey);
                                            await localDriver.removeItem('travelers');
                                            localStorage.removeItem('atracking'); // one-shot: don't re-credit a later unrelated booking
                                            this.newoid = newoid;
                                            this.showPaySucc = true;
                                            await this.insuranceStore.purchase(res.order_id, address, {
                                                cardHolderName: data.cc_owner[0],
                                                cardNumber: data.cc_number[0],
                                                cvc: data.cc_cvc[0],
                                                expirationMonth: data.cc_expire_date_month[0],
                                                expirationYear: data.cc_expire_date_year[0]
                                            });
                                        }

                                        this.GoogleTrack(res.order_id, await this.checkPayment(98), odata.currency);
                                        const special_request = await localDriver.getItem('special_request') || '';
                                        if (special_request) await this.sendMsg(newoid, special_request);
                                    } else if (res?.duplicate) {
                                        // A repeated submit of this checkout: show the order's real state.
                                        this.recoverPayout(data.token, bt1);
                                    } else {
                                        this.resetPayButton(bt1);
                                        this.openPayFail(res?.msg);
                                        try {
                                            const cInfo = await localDriver.getItem('customerInfo') || {};
                                            const info = {
                                                email: cInfo.email,
                                                postData: data,
                                                response: {
                                                    success: res?.success ?? false,
                                                    msg: res?.msg ?? '',
                                                    redirect: res?.redirect ?? '',
                                                    data: res?.data ?? null,
                                                },
                                            };
                                            delete info.postData.cc_number;
                                            delete info.postData.cc_cvc;
                                            this.pagelog(new Request(), 'paymentfail', info);
                                        } catch (e) { /* Payment failure details are best-effort logging only. */ }
                                    }
                                } catch (error) {
                                    this.pagelog(new Request(), 'paymentCallbackErr', {
                                        order_id: newoid,
                                        paymentConfirmed: stripePaymentConfirmed,
                                        msg: error?.message || 'payment_callback_failed',
                                    });
                                    this.resetPayButton(bt1);
                                    if (stripePaymentConfirmed) {
                                        this.newoid = newoid;
                                        this.showPaySucc = true;
                                        return;
                                    }
                                    this.openPayFail('checkout_request_failed');
                                }
                            },
                            url,
                            (error) => {
                                if (settle.timedOut) return;
                                settle.done = true;
                                clearTimeout(settle.timer);
                                this.resetPayButton(bt1);
                                this.openPayFail('checkout_request_failed');
                                this.pagelog(new Request(), 'paymentRequestErr', { msg: error?.message || 'checkout_request_failed' });
                            }
                        );
                } 
            }
            else {
                this.pagelog(new Request(), 'noPayout', { redborderElem: payoutValidation, gatewayopen: this.gatewayopen })
            }
        },
        // Called by PaypalButton's createOrder when order_id=0 (booking flow).
        // Called by PaypalButton's beforeCreate prop before the PayPal popup opens.
        // Runs form validation first; if the order doesn't exist yet (booking flow),
        // creates the local pending order, then returns { order_id, payment_id }.
        async beforePaypalCreate() {
            const errors = this.payoutValidation();
            if (!this.gatewayopen || errors.length > 0) {
                throw new Error('Please complete all required fields and agree to the terms.');
            }
            if (this.order_id > 0) {
                return { order_id: this.order_id, payment_id: this.payment_id };
            }
            // checkout/payment performs the authoritative cart validation while
            // creating the local pending order. Running precheckBeforePayout()
            // here first calls checkout/checkout, which creates cart_transaction;
            // a retry then treats that same token as expired and prevents the
            // PayPal Orders API from ever opening its buyer-login popup.
            return this.createPaypalLocalOrder();
        },

        // Creates a pending local order via checkout/payment with orderback=1,
        // mirroring the pp_standard pre-create pattern.
        // Returns { order_id, payment_id } for PaypalButton to use.
        async createPaypalLocalOrder() {
            return new Promise((resolve, reject) => {
                const selectedCreditIds = this.getSelectedCreditIds();
                const coinAmount = parseFloat(this.payment_credit?.amount || 0);
                const selectedCreditIdSet = selectedCreditIds.map(id => String(id));
                const selectedCreditAmount = (Array.isArray(this.credits) ? this.credits : Object.values(this.credits || {}))
                    .filter(item => selectedCreditIdSet.includes(String(item?.ctid)))
                    .reduce((total, item) => total + (parseFloat(item?.amount || 0) || 0), 0);
                const d = {
                    v:              202003,
                    netprice:       parseInt(this.netprice) + 1,
                    token:          this.orderStore.token,
                    csyn:           1,
                    payment_method: 'paypal_checkout',
                    payment_type:   this.payment_type,
                    agree:          1,
                    orderback:      1,
                };
                if (selectedCreditIds.length > 0) {
                    d.credit = selectedCreditIds.join(',');
                    d.payment_amount = selectedCreditAmount;
                }
                if (coinAmount > 0) {
                    d.seperateCredit = {
                        currency: this.getPaymentCreditCurrency(),
                        amount: coinAmount,
                    };
                }
                new Request().webPost(d, (res) => {
                    const oid = res.order_id ? parseInt(res.order_id) : 0;
                    // payment_id is returned as array (same as pp_standard)
                    const pid = res.payment_id
                        ? (Array.isArray(res.payment_id) ? parseInt(res.payment_id[0]) : parseInt(res.payment_id))
                        : 0;
                    if (oid > 0) {
                        this.order_id   = oid;
                        this.payment_id = pid;
                        resolve({
                            order_id: oid,
                            payment_id: pid,
                            credit: d.credit || '',
                            payment_amount: d.payment_amount || '',
                            coin: d.seperateCredit || null,
                        });
                    } else {
                        reject(new Error(res.msg || 'Failed to create order. Please try again.'));
                    }
                }, 'checkout/payment');
            });
        },

        // Called by PaypalButton component when PayPal payment is successfully captured
        async onPaypalSuccess(result) {
            const newoid = result.order_id
            if (!newoid) return

            await localDriver.removeItem(this.odkey)
            await localDriver.removeItem('travelers')
            this.newoid = newoid
            this.showPaySucc = true

            // PayPal does not provide card details; pass empty card info for insurance purchase
            const state = this.payinfo.province
            const address = formatAddress(
                this.payinfo.country, state, this.payinfo.city,
                this.payinfo.address, this.payinfo.postal
            )
            await this.insuranceStore.purchase(newoid, address, {
                cardHolderName: '',
                cardNumber:     '',
                cvc:            '',
                expirationMonth: '',
                expirationYear:  '',
            })

            this.GoogleTrack(newoid, await this.checkPayment(98), this.odata.currency)

            const special_request = await localDriver.getItem('special_request') || ''
            if (special_request) {
                await this.sendMsg(newoid, special_request)
            }
        },

        // Called by PaypalButton when PayPal capture fails
        onPaypalFail(result) {
            const failureType = classifyPaypalFailure(result)
            const hasSpecificCheckoutError = this.payFail && (
                this.payFailMessage === this.cartPayFailMessage ||
                this.payFailMessage === this.reservationPayFailMessage
            )

            if (!hasSpecificCheckoutError) {
                this.openPayFail(failureType)
            }
        },

        // Called by PaypalButton when buyer cancels in the PayPal popup
        onPaypalCancel() {
            // No action needed; buyer stays on the payment page
        },

        // Fires when the buyer clicks a PayPal button while paypalDisabled is true.
        // Runs payoutValidation so the terms container picks up the .redborder highlight,
        // and surfaces the missing-terms message next to the checkbox instead of under the button.
        onPaypalDisabledClick() {
            this.payoutValidation();
            const needGeneralTerm = this.generalPolicyLink !== '' && !this.checkedTerm;
            const needFlightTerm  = this.flight_agree !== '' && !this.checkedFlightTerm;
            if (needGeneralTerm || needFlightTerm) {
                this.termsAgreeError = 'Please agree to the terms before continuing.';
            } else {
                this.termsAgreeError = 'Please complete all required fields before continuing.';
            }
        },

        clearTermsAgreeError() {
            this.termsAgreeError = '';
            document.querySelectorAll('.product_policy_agree.redborder, .termFlightdiv.redborder')
                .forEach((el) => el.classList.remove('redborder'));
        },

        async sendMsg(order_id, content) {
            const type = "TEXT";
            const linkType = "ttg.order.operator";
            const topic = await ImService.createTopicIfNotExistByLink(linkType, order_id, '');
            const req = {
                topicId: topic.id,
                toDomain: "ttg.operator",
                link: order_id,
                linkType: "",
                toId: topic.peer.id,
                contentType: type,
                content: content,
            }
            try {
                await ImService.send(req);
                await InquiryService.saveHelpDeskNotes({
                    orderId: order_id,
                    msgType: type,
                    msgContent: content
                })
            }
            catch (ee) {
                console.log(ee);
            }
        },
        initFlightTerm(odata, t) {
            //let odata = await localDriver.getItem(this.odkey)) || {};
            //console.log('=====initFlightTerm=======',odata)
            this.flight_agree = '';
            this.checkedFlightTerm = true;
            this.Announcements = [];
            if (t > 0) {                
                if (notEmpty(odata.flightOffer)) {
                    this.checkedFlightTerm = false;
                    if (notEmpty(odata.flightOffer.Announcements)) {
                        this.Announcements = odata.flightOffer.Announcements;
                        this.flight_agree = 'Please check this box to indicate that <span class="fontBold"  style="color:#0099cc!important;">you have read and verified the flight details and travelers\' information.</span>';
                    }
                    else {
                        this.flight_agree = 'Please check this box to indicate that <span class="fontBold"  style="color:#0099cc!important;">you have read and verified the flight details and travelers\' information.</span>';

                        let info = {
                            ispackage: odata.product_info.model.toUpperCase().slice(0, 3) == 'FP-' ? 1 : 0,
                            finalprice: (parseFloat(odata.cityprice) + parseFloat(odata.flightOffer.price))
                        };
                        let pd = { offer_id: odata.flightOffer.id, rid: odata.flightOffer.rid, info: info };
                        //console.log('=====initFlightTerm=======',pd)
                        new Request().webPost(
                            pd,
                            (res) => {
                                this.Announcements.push('Tickets will be issued immediately upon full airfare payment.');
                                for (let tidx in res.data.terms) {
                                    this.Announcements.push(res.data.terms[tidx]);
                                }
                                this.Announcements.push('Once issued, any name changes may require cancellation and rebooking of a new ticket.');
                                this.Announcements.push('Additional baggage charges may apply.The baggage allowance for infants and children can differ from that of adults, depending on the airline and destination.');
                                this.Announcements.push('You will receive the flight confirmation within 24-72 hours after issued.');
                                this.Announcements.push('We highly recommend that you select and pay the Protection ToGo Plan at the time of booking.');
                                //console.log('------initFlightTerm=--',[odata,pd,res,this.Announcements]);
                            },
                            'product/flight/getFares'
                        );
                    }
                }
            }
        },
        async hasFlightSign() {
            var odata = await localDriver.getItem(this.odkey) || {};
            var flight = odata.flightOffer || {};
            // Flight terms depend on the order content, not on isSignature (which now also
            // needs payment_method == eselectplus_api and is still empty at this point).
            this.initFlightTerm(odata, (notEmpty(flight) || this.insuranceStore.needPurchase()) ? 1 : 0);
            //console.log('--------------------------------------odata----------------------------------------', odata);
            if (flight.rid > 0 && flight.id > 0) {
                var total = parseFloat(flight.price) * flight.persons;
                this.flightdetails = 1;
            }
            this.getCounties();
        },
    }
};
</script>
<style>
.pop_con {
    margin-top: 3rem;

    overflow-y: auto;
    height: 65vh;
}

.button {
    width: 50%;
    text-align: center;
    font-weight: bold;
    margin-top: 2rem;
}

.refer {
    background: #ffffff;
    border: 1px solid #111111;
}

.win_con {
    text-align: center;

    width: 100%;
}

.customer_popwin {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    padding: 50px 10px;
    gap: 24px;
    margin: 0 !important;
    box-sizing: border-box;
}

.customer_popwin.block {
    margin: 0 !important;
}

.customer_popwin .r {
    width: 100%;
    margin: 0 !important;
    padding: 0;
}

.customer_popwin .win_title {
    font-size: 32px;
    line-height: 1;
    font-weight: 600;
    color: #333;
    margin: 0 !important;
}

.customer_popwin .win_con {
    width: 100%;
    padding: 0 !important;
    font-size: 16px;
    line-height: 1.5;
    color: #333;
    text-align: center;
}

.customer_popwin .button {
    width: 100%;
    margin: 0;
    height: 56px;
    min-height: 56px;
    padding: 16px 32px;
    font-size: 16px;
    line-height: 1.5;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.customer_popwin .pay-success-copy {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 593px;
}

.customer_popwin .pay-success-actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 357px;
}

.customer_popwin .childcenter {
    justify-content: center !important;
}

.customer_popwin .win_img {
    display: flex;
    justify-content: center;
    margin: 0 !important;
}

.customer_popwin .win_img img {
    width: 89px !important;
    height: 89px !important;
    filter: grayscale(1) brightness(0.28) contrast(1.1);
}

.radio-border .el-radio__input .el-radio__inner {
    border: 2px solid #0066cc !important;
    /* Set border color and thickness */
}

:deep(.payment .el-checkbox) {
    white-space: nowrap !important;
    text-wrap: nowrap !important;
}

.prop {
    z-index: 999999
}

.pay-success-overlay {
    position: fixed;
    inset: 0;
    z-index: 2147483647;
    display: grid;
    place-items: center;
    padding: 1.2rem;
    box-sizing: border-box;
    background: rgba(25, 32, 27, 0.56);
}

.prop .con {
    position: absolute;
    box-sizing: border-box;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 2rem;
    box-shadow: 0px 10px 60px -10px #00000014;
    max-height: 80vh;
    overflow-y: auto;
}

.prop .con.pay-success-con {
    width: min(813px, calc(100vw - 64px));
    height: min(501px, calc(100dvh - 64px));
    max-height: calc(100dvh - 64px);
    padding: 0;
    border-radius: 32px;
    overflow: hidden;
}

.pay-success-overlay .con.pay-success-con {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    z-index: 1;
}

.product_policy_agree {
    display: flex;
    align-items: center;
    font-size: 1.4rem;
}

.terms-agree-error {
    color: #ff5722;
    font-size: 1.2rem;
    margin-top: 0.6rem;
}

.product_policy {
    height: 90%;
    overflow-y: auto;
    padding: 2rem;
    margin-bottom: 2rem;
    font-size: 1.4rem;
}

.product_policy ol {
    padding-bottom: 1rem;
    padding-left: 2rem;
}

.product_policy .name {
    text-align: center;
    font-weight: bold;
    font-size: 1.7rem;
}

.verify {
    margin-top: 1.8rem;
}

.red_border {
    border: 1px solid red !important;
    ;
}

.fontBold {
    font-weight: bolder;
}

.termFlight {
    background: #fff;
    padding: 1rem;
}

.termFlight .label {
    font-weight: bolder;
    font-size: 1.8rem;
    margin: 0.8rem 0.1rem;
}

.termFlight .airfaretipscon {
    padding: 2.4rem;
    font-family: Poppins;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 2.4rem;
    text-align: left;
    color: #333;
}

.termFlight .airfaretipscon p {
    padding-left: 2.4rem;
    position: relative;
}

.termFlight .airfaretipscon p::before {
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background: #333;
    position: absolute;
    top: 1rem;
    left: 1rem;
}

.termFlight .ico {
    cursor: pointer;
    width: 2rem;
    display: inline-block;
    margin-bottom: -0.5rem;
}

.termFlight .fterm .contxt {
    padding: 0.8rem;
    border-radius: 0.5rem;
    background: #F6F6F6;
}

.el-input--prefix .el-input__inner,
.el-input--suffix .el-input__inner,
.el-textarea__inner,
.el-input__inner {
    font-size: 1.6rem !important;

}

.el-select__wrapper {
    padding: 0;
    border: 0;
    background: transparent;
    box-shadow: none;
    height: 100%;
    font-size: 1.6rem !important;

}

.el-select-dropdown.is-multiple .el-select-dropdown__item.is-selected:after {
    display: none;
}

.el-select__wrapper.is-hovering,
.el-select__wrapper.is-focused,
.el-select__wrapper:hover,
.el-select__wrapper:focus-visible {
    border: 0;
    background: transparent;
    outline: none;
    box-shadow: none !important;
}

.modelbox {
    & .el-select__selected-item {
        span {
            font-weight: 400;
            color: #000;
            font-size: 1.5rem;
        }
    }

    & .is-transparent {
        span {
            color: var(--el-placeholder-color);
        }
    }
}
</style>
<!-- Shared area -->
<style scoped>
.page {
    background: #FAFAFA;
}

.leftpage {
    width: 68.6%;
}

.rightpage {
    width: 29%;
}

.el-date-editor.el-input,
.el-date-editor.el-input__wrapper {

    font-weight: normal !important;
    color: #ddd !important;
    font-size: 11px !important;
    margin-top: 0px !important;
    height: 4.8rem !important;
    margin-bottom: 0px !important;
    vertical-align: middle;

}

:deep(.agree) {
    background: #fff;
    border: 1px #fff solid;
    font-size: 1.4083rem;
    display: inline;
    font-weight: normal;
    color: #4F6F52
}

.totalbox {
    padding: 0 2.4rem;
    border-radius: 1.2rem;
    margin-bottom: 2.4rem;
    background: #fff;
}

.totalbox .titbox {
    padding-top: 2rem;
    color: #333;
    font-family: Poppins-Bold;
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 2.2rem;
}

.totalbox .infobox {
    padding: 1.6rem 0 2.4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #EAEAEA
}

.totalbox .infobox .pic {
    width: 8rem;
    height: 7rem;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 0.8rem;
}

.totalbox .infobox .txt {
    width: calc(100% - 9.2rem);
    font-family: Poppins;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.0rem;
    text-align: left;
}

.totalbox .listbox {
    padding: 1.2rem 0;
    border-bottom: 1px solid #EAEAEA
}

.totalbox .listbox:last-child {
    border-bottom: 0;
}

.totalbox .listbox .tit {
    font-family: Poppins-Bold;
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 2rem;
    padding: 0.8rem 0;
}

.totalbox .listbox .row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    font-family: Poppins;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2rem;
    padding: 0.8rem 0;
}

.totalbox .listbox .row.total {
    font-size: 1.6rem;
    font-family: Poppins-Bold;
    font-weight: 700;
}

.totalbox .listbox .row .label {
    color: #666666;
}

.totalbox .listbox .row .airico {
    width: 2rem;
    display: block;
}

.totalbox .listbox .row.total .label,
.totalbox .listbox .row .label span.black,
.totalbox .listbox .row .contxt {
    color: #333333;
}

.totalbox .listbox .row .green {
    color: #4F6F52 !important;
}

.bottombtn {
    border-top: 1px solid #EAEAEA;
    background: #fff;
    padding-top: 0;
}

/* Pin PayPal checkout footer to viewport bottom; other methods already have their own fixed footer. */
.paypal-fixed-footer :deep(.bottombtn) {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1200;
    background: #fff;
    box-shadow: 0 -0.4rem 1.2rem rgba(0, 0, 0, 0.08);
}

/* Mobile: let the PayPal button use the free width next to "Back" instead of the 400px cap. */
@media screen and (max-width: 750px) {
    .paypal-fixed-footer :deep(.btnbox) {
        gap: 1rem;
        padding-right: 1.2rem;
    }
    .paypal-fixed-footer :deep(.paypal-wrapper) {
        max-width: none;
        width: auto;
        flex: 1 1 auto;
        min-width: 0;
    }
    .paypal-fixed-footer :deep(#paypal-button-container) {
        width: 100%;
    }
    /* The PayPal SDK renders its own inner button, which keeps the width it had at render time. */
    .paypal-fixed-footer :deep(#paypal-button-container .paypal-buttons),
    .paypal-fixed-footer :deep(#paypal-button-container [data-funding-source]),
    .paypal-fixed-footer :deep(#paypal-button-container iframe) {
        width: 100% !important;
        max-width: none !important;
    }
}

.bottombtn .btnbox {
    padding: 1.6rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    line-height: 4.8rem;
    font-family: Poppins-Bold;
    font-size: 1.6rem;
    font-weight: 700;
}

.bottombtn .back {
    border-radius: 0.8rem;
    background: #F5F5F5;
    width: 12rem;
    color: #333;
    cursor: pointer;
}

.bottombtn .continue {
    cursor: pointer;
    background: #4F6F52;
    border-radius: 0.8rem;
    width: calc(100% - 13.6rem);
    color: #fff;
}

/* Mobile */
@media screen and (max-width:750px) {
    .prop .con {

        height: 90vh;



    }



    .prop .con .fixed_closer {

        top: 0.0rem !important;

    }

    .prop .con.pay-success-con {
        width: min(350px, calc(100vw - 24px));
        height: min(436px, calc(100dvh - 24px)) !important;
        max-height: calc(100dvh - 24px);
        padding: 0 !important;
        border-radius: 24px;
        overflow-y: auto;
    }

    .customer_popwin {
        padding: 32px 20px;
        gap: 12px;
    }

    .customer_popwin .r {
        margin: 0 !important;
    }

    .customer_popwin .win_img img {
        width: 89px !important;
        height: 89px !important;
    }

    .customer_popwin .win_title {
        font-size: 22px;
        line-height: 1.5;
        margin: 0;
    }

    .customer_popwin .win_con {
        font-size: 12px;
        line-height: 1.5;
        text-align: center;
    }

    .customer_popwin .button {
        width: 100%;
        max-width: none;
        margin: 0;
        height: 42px;
        min-height: 42px;
        padding: 12px 24px;
        font-size: 12px;
        line-height: 1.5;
        border-radius: 8px;
    }

    .customer_popwin .win_img {
        margin: 0 0 8px !important;
    }

    .customer_popwin .pay-success-copy {
        gap: 12px;
        max-width: none;
    }

    .customer_popwin .pay-success-actions {
        gap: 12px;
        max-width: none;
        margin-top: 8px !important;
    }


    .product_policy_agree {
        display: flex;
        align-items: center;
        font-size: 1.4rem;
        margin-top: 3rem;
        line-height: 1.8rem;
    }

    .product_policy .name {
        font-size: 1.5rem;
    }

    .product_policy {
        height: 100%;

        overflow-y: auto;
        padding: 0rem;

        margin-bottom: 0rem;
        font-size: 1.4rem;
    }

    .product_policy ol {
        padding-bottom: 1rem;

    }

    .totalbox .listbox .row.total {
        font-size: 1.4rem !important;
        ;

    }

    .totalbox .listbox .row .label {
        font: size 1.4rem !important;
        ;
    }

    .acceptbox span,
    .termFlightdiv,
    .termFlightdiv span {


        line-height: 1.8rem;
        word-wrap: break-word;
        /* Legacy property name */
        overflow-wrap: break-word;
        /* Current standard property name */
        white-space: normal;
    }

    .termFlight .airfaretipscon .label,

    .termFlight .airfaretipscon .contxt {

        font-size: 1.5rem;

    }

    .page {
        padding-top: 5.6rem;
    }

    .presshead {
        top: 5.6rem;
        padding: 0 1.6rem;
        height: 5.6rem;
    }

    .presshead .pressbox .box {
        margin: 0 0.6rem;
    }

    .presshead .btn {
        width: 5.6rem;
        display: block;
    }

    .presshead .pressbox .box .txt {
        display: none;
        white-space: nowrap;
        font-size: 1.6rem;
    }

    .presshead .pressbox .box.on:last-child .txt {
        margin-left: 0.8rem;
        display: block
    }


}
</style>
<!-- Flight Preference -->
<style scoped>
.topflight {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 2.4rem 2rem;
    background: #fff;
    border-radius: 1.2rem;
    margin: 3.2rem 0 0;
}

.topflight .box {
    padding: 0 1.6rem;
    height: 5.6rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 0.8rem;
    background: #F6F6F6;
    margin-right: 1rem;
    width: 19rem;
    position: relative;
}

.topflight .box .checkbox {
    position: absolute;
    top: 100%;
    left: 0%;
    background: #fff;
    border-radius: 1.2rem;
    padding: 1.2rem;
}

.topflight .box .titbox {
    width: calc(100% - 2rem);
}

.topflight .box .tit {
    font-family: Poppins;
    font-size: 1.3rem;
    font-weight: 400;
    line-height: 1.6rem;
    color: #666666;
}

.topflight .box .txt {
    font-size: 1.6rem;
    color: #333;
}

.topflight .box .icon_down {
    width: 2rem;
    height: 2rem;
    display: block;
}

.topflight .reset .icon {
    width: 2.4rem;
    display: block;
}

.topflight .reset {
    cursor: pointer;
    width: auto;
}

.topflight .btnbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.topflight .btn {
    background: #4F6F52;
    line-height: 5.6rem;
    padding: 0 1.6rem;
    border-radius: .8rem;
    font-family: Poppins-Bold;
    font-size: 1.4rem;
    font-weight: 700;
    cursor: pointer;
    color: #fff;
}

.title {
    font-family: Poppins-Bold;
    font-size: 2.2rem;
    font-weight: 700;
    line-height: 3.0rem;
    color: #333;
}

.flightlist {
    margin-bottom: 3.2rem;
}

.flightbox {
    background: #FFFFFF;
    border-radius: 1.2rem;
    padding: 1.8rem 2.4rem 2rem;
    margin-top: 1.6rem;
}

.flightbox .omitbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.flightbox .omitbox .infobox {
    width: calc(100% - 21.2rem);
    padding-right: 2.4rem;
    border-right: 1.5px dashed #CCCCCC;
}

.flightbox .fenge {
    border-bottom: 1px solid #EAEAEA;
    height: 0;
    width: 100%;
    margin: 2rem 0;
}

.flightbox .omitbox .infobox .airplay {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-family: Poppins;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.0rem;
    color: #333;
    margin-bottom: 1.4rem;
}

.flightbox .omitbox .infobox .airplay span:last-child {
    color: #999;
}

.flightbox .omitbox .infobox .airplay .airico {
    width: 2.4rem;
    margin-right: 1.2rem;
}

.flightbox .omitbox .infobox .process {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.flightbox .omitbox .infobox .process .info {
    width: 25%;
    color: #333;
}

.flightbox .omitbox .infobox .process .info:last-child {
    text-align: right;
}

.flightbox .omitbox .infobox .process .info .timebox {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    font-family: Poppins-Bold;
    font-weight: 700;
    position: relative;
}

.flightbox .omitbox .infobox .process .info:last-child .timebox {
    justify-content: flex-end;
}

.flightbox .omitbox .infobox .process .info .timebox .time {
    font-size: 2.0rem;
    line-height: 2.8rem;
    display: block;
}

.flightbox .omitbox .infobox .process .info .timebox .date {
    font-size: 1.4rem;
    line-height: 2.2rem;
    margin-left: 0.6rem;
}

.flightbox .omitbox .infobox .process .info .timebox .date i {
    color: #666;
    font-family: Poppins;
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1.6rem;
    text-align: right;
    position: absolute;
    right: 0;
    top: -1em;
}

.flightbox .omitbox .infobox .process .info .city {
    margin-top: 0.6rem;
    font-size: 1.4rem;
    line-height: 2.0rem;
}

.flightbox .omitbox .infobox .process .linebox {
    width: 45%;
}

.flightbox .omitbox .infobox .process .upbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 5% 0.7rem;
    margin-bottom: 0.5rem;
    border-bottom: 1px dashed #4F6F52;
}

.flightbox .omitbox .infobox .process .upbox .ico {
    width: 1.6rem;
}

.flightbox .omitbox .infobox .process .txt {
    color: #666;
    font-family: Poppins;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.0rem;
    text-align: center;

}

.flightbox .omitbox .btnbox {
    width: 17.6rem;
    text-align: center;
    font-family: Poppins-Bold;
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 3.6rem;
}

.flightbox .omitbox .btnbox .selectbtn {
    background: #4F6F52;
    color: #fff;
    border-radius: 0.8rem;
    cursor: pointer;
}

.tbalist .flightbox .omitbox .btnbox .selectbtn {
    border-radius: 1.8rem;
}

.flightbox .omitbox .btnbox .pricebtn {
    border: 1px solid #4F6F52;
    border-radius: 0.8rem;
    color: #4F6F52;
    cursor: pointer;
}

.flightbox .omitbox .btnbox .showbtn {
    border: 1px solid #EAEAEA;
    border-radius: 0.8rem;
    color: #4F6F52;
    margin-top: 7rem;
    cursor: pointer;
}

.flightbox .detail {
    background: #FAFAFA;
    border-radius: 1.2rem;
    padding: 2rem 2.4rem;
    margin-top: 2rem;
}

.flightbox .detail .tit {
    font-family: Poppins-Bold;
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 2.8rem;
    color: #071525;
    margin: 3.2rem 0 0.8rem;
}

.flightbox .detail .tit:first-child {
    margin-top: 0;
}

.flightbox .detail .processbox {
    margin: 0.8rem 0;
    padding: 0.1rem 0 0;
    border-left: 1px solid #CCCCCC;
}

.flightbox .detail .processbox .layover {
    color: #999;
    font-family: Poppins;
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 2.0rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1.2rem;
    width: calc(38rem);
}

.flightbox .detail .processbox .layover .ico {
    width: 2rem;
    display: block;
    margin-right: 1rem;
}

.flightbox .detail .processbox .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1.2rem;
    position: relative;
}

.flightbox .detail .processbox .row::before {
    content: '';
    position: absolute;
    top: calc(100% - 0.2rem);
    left: 18.9rem;
    border-left: 1px solid #4F6F52;
    width: 0;
    height: 1.6rem;
    display: block;
}

.flightbox .detail .processbox .row.dao::before {
    display: none;
}

.flightbox .detail .processbox .row .left {
    width: 16rem;
    text-align: right;
}

.flightbox .detail .processbox .row .right {
    width: calc(100% - 22rem);
    text-align: left;
}

.flightbox .detail .processbox .row .dian {
    background: #4F6F52;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
}

.flightbox .detail .processbox .row .ico {
    width: 1.6rem;
    display: block;
}

.flightbox .detail .processbox .row .timebox {
    font-family: Poppins;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 2.2rem;
    color: #333;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
}

.flightbox .detail .processbox .row .timebox .time {
    font-family: Poppins-Bold;
    font-weight: 700;
    margin-left: 1rem;
    display: block;
}

.flightbox .detail .processbox .row .hourbox {
    font-family: Poppins;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.0rem;
    color: #666666;
}

.flightbox .detail .processbox .row .desc {
    font-family: Poppins-Bold;
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 2.2rem;
    color: #333333;
}

.flightbox .detail .processbox .row .coverbox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}

.flightbox .detail .processbox .row .coverbox .covicon {
    width: 3.6rem;
    display: block;
    margin-right: 0.8rem;
}

.flightbox .detail .processbox .row .coverbox .covicon:last-child {
    margin-right: 0;
}

.flightbox .detail .processbox .row .coverbox .airplay {
    margin-right: 1.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.8rem 1.2rem;
    background: #F5F5F5;
    border-radius: 0.8rem;
    font-family: Poppins;
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 2.0rem;
    color: #666;
}

.flightbox .detail .processbox .row .coverbox .airplay .airico {
    width: 2rem;
    margin-right: 1.2rem;
    display: block;
}

.flightbox .detail .tipstxt {
    font-family: Poppins;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.0rem;
    color: #333;
}

.flightbox .detail .tipstxt span {
    color: #1B80DE;
}

.flightbox .detail .tipstxt .ico {
    width: 2rem;
    display: inline-block;
    margin-bottom: -0.5rem;
}

/* Mobile */
@media screen and (max-width:750px) {
    .filter {
        display: flex !important;
        justify-content: center;
        align-items: center;
        background: #FFFFFF;
        border-radius: 2.4rem;
        line-height: 4.8rem;
        color: #000;
        font-family: Poppins;
        font-size: 1.6rem;
        font-weight: 500;
        margin-top: 1.6rem;
    }

    .filter .ico {
        width: 2.4rem;
        margin-right: 1rem;
    }

    .leftpage,
    .rightpage {
        width: 100%;
        margin-top: 0;
    }

    .flightlist {
        margin-bottom: 2.4rem;
    }

    .flightbox {
        padding: 1.2rem 1.6rem 1.6rem;
    }

    .flightbox .omitbox {
        display: block;
    }

    .flightbox .omitbox .infobox {
        width: calc(100%);
        padding-right: 0;
        border-right: 0;
    }

    .flightbox .omitbox .infobox .airplay i {
        display: none;
    }

    .flightbox .omitbox .infobox .airplay span {
        display: block;
    }

    .flightbox .omitbox .btnbox {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row-reverse;
        margin-top: 1.6rem;
    }

    .flightbox .omitbox .btnbox .selectbtn,
    .tbalist .flightbox .omitbox .btnbox .selectbtn,
    .flightbox .omitbox .btnbox .pricebtn,
    .flightbox .omitbox .btnbox .showbtn {
        width: 48%;
        margin-top: 0;
        border-radius: 0.8rem;
    }

    .flightbox .omitbox .infobox .process .info {
        width: 30%;
    }

    .flightbox .omitbox .infobox .process .info .timebox {
        display: block;
    }

    .flightbox .omitbox .infobox .process .info .city,
    .flightbox .omitbox .infobox .process .info .timebox .date {
        margin: 0;
        line-height: 2rem;
    }

    .flightbox .omitbox .infobox .process .linebox {
        width: 40%;
    }

    .flightbox .omitbox .infobox .process .upbox {
        padding: 0 0 0.7rem;
    }

    .flightbox .detail {
        padding: 0.8rem 1.2rem 1.2rem;
        margin-top: 1.6rem;
    }

    .flightbox .fenge {
        margin: 1.6rem 0;
    }

    .flightbox .detail .tit {
        margin: 2.4rem 0 0.8rem;
    }

    .flightbox .detail .processbox .layover {
        width: calc(22.4rem);
    }

    .flightbox .detail .processbox .row {
        align-items: flex-start;
    }

    .flightbox .detail .processbox .row::before {
        left: 11.1rem;
        height: calc(100% - 1.6rem);
        top: 2.6rem;
    }

    .flightbox .detail .processbox .row .left {
        width: 9.2rem;
    }

    .flightbox .detail .processbox .row .right {
        width: calc(100% - 13rem);
        text-align: left;
    }

    .flightbox .detail .processbox .row .coverbox .airplay {
        margin-right: 0;
        padding: 0.8rem 1rem;
        align-items: flex-start;
    }

    .flightbox .detail .processbox .row .coverbox .airplay .airico {
        width: 1.8rem;
        margin-right: 1rem;
        display: block;
    }

    .flightbox .detail .processbox .row .coverbox .covicon {
        margin-top: 0.8rem;
    }

    .flightbox .detail .processbox .row .ico {
        margin-top: 0.3rem;
    }

    .flightbox .detail .processbox .row .dian {
        margin-top: 0.6rem;
    }


    .Filterprop {
        background: #00000080;
        z-index: 10;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }

    .Filterprop .con {
        width: 100% !important;
        position: absolute;
        bottom: 0;
        top: auto;
        left: 0;
        transform: translate(0, 0);
        border-radius: 1.2rem 1.2rem 0 0;
        background: #fff;
        padding: 1.6rem 0 0 !important;
    }

    .Filterprop .close {
        position: absolute;
        right: 1.6rem;
        top: 1.6rem;
        width: 20px;
        height: 20px;
        box-sizing: content-box;
        padding: 0.8rem;
        border-radius: 50%;
        background: #fff;
        box-shadow: 0px 1rem 6rem 1rem #00000014;
    }

    .titFilters {
        color: #333;
        font-family: Poppins-Bold;
        font-size: 2.2rem;
        font-weight: 700;
        line-height: 3.0rem;
        text-align: left;
        padding: 0 1.6rem;
    }

    .topflight {
        max-height: 80vh;
        margin-top: 2rem;
        overflow: auto;
        display: block;
        padding: 0 1.6rem 10.4rem;
        position: relative;
        border-radius: 0;
    }

    .topflight .btnbox {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 1.6rem 2.4rem;
        border-top: 1px solid #EAEAEA;
        background: #FFFFFF;
        z-index: 9;
    }

    .topflight .btnbox>div {
        width: 48%;
        text-align: center;
        height: 4.8rem;
        line-height: 4.8rem;
        font-family: Poppins-Bold;
        font-size: 1.6rem;
        font-weight: 700;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .topflight .btnbox .reset {
        color: #4F6F52;
        border: 1px solid #EAEAEA;
        background: #FFFFFF;
        border-radius: 0.8rem;
    }

    .topflight .box {
        padding: 0;
        height: auto;
        display: block;
        border-radius: 0;
        background: transparent;
        margin-right: 0;
        width: auto;
    }

    .topflight .box .txt {
        display: none;
    }

    .topflight .box .checkbox {
        position: relative;
        top: 0%;
        left: 0%;
        padding: 1.6rem 0
    }

    .topflight .box .checkbox .el-checkbox {
        display: block
    }

}
</style>

<!-- Order Filling -->
<style scoped>
.modelbox {
    padding: 2rem 2.4rem 2.4rem;
    border-radius: 1.2rem;
    background: #fff;
    margin-bottom: 2.4rem;
}

.modelbox .roombox {
    margin-top: 2.4rem;
}

.modelbox .roombox .titbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modelbox .roombox .titbox .tit {
    color: #333;
    font-family: Poppins;
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 2.2rem;
}

.modelbox .roombox .titbox .typeflex {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.modelbox .roombox .titbox .typeflex .peoplenum,
.modelbox .roombox .titbox .typeflex .typebox {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1.2rem;
    height: 2.4rem;
    border: 1px solid #EAEAEA;
    background: #F5F5F5;
    border-radius: 1.2rem;
    font-family: Poppins-Bold;
    font-size: 1.6rem;
    font-weight: 700;
    margin-left: 0.8rem;
}

.modelbox .roombox .titbox .typeflex .ico {
    height: 2rem;
    display: block;
    margin-right: 1rem;
}

.modelbox .roombox .titbox .typeflex .typebox .ico:last-child {
    margin-right: 0;
}

.modelbox .roombox .traveler {
    margin-top: 0.8rem;
    padding: 1.3rem 1.6rem;
    background: #F6F6F6;
    border-radius: 0.8rem;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 2.2rem;
    color: #333;
}

.modelbox .roombox .traveler .label {
    width: 7.6rem;
}

.modelbox .roombox .traveler .info {
    font-weight: 500;
    cursor: pointer;
}

.modelbox .roombox .traveler .selbtn {
    font-weight: 500;
    cursor: pointer;
    color: #4F6F52;
}

.modelbox .formbox {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
}

.modelbox .formbox .ponitshow {
    align-items: flex-end !important;
}

.modelbox .formbox .row {
    width: 48%;
    margin-top: 2rem;
}

.modelbox .formbox .row.width {
    width: 100%
}

.modelbox .formbox .row .label {
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.0rem;
    margin-bottom: 0.6rem;
    color: #666;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.modelbox .formbox .row .label i {
    color: #F92D2D;
    margin-left: 0.6rem;
}

.modelbox .formbox .row .label .ico {
    width: 2rem;
    height: 2rem;
    margin-left: 0.6rem;
    display: block
}

.modelbox .formbox .row .input {
    background: #F6F6F6;
    border-radius: 0.8rem;
    height: 5.4rem;
    line-height: 5.2rem;
    padding: 0 1.6rem;
    font-size: 1.6rem;

    width: 100%;
    /*     color:#bbb !important; */
    font-weight: normal !important;
}

/* Stripe Elements mounts an iframe — let Stripe control the inner appearance */
.modelbox .formbox .row .stripe-input {
    background: #F6F6F6;
    border-radius: 0.8rem;
    padding: 1.5rem 1.2rem;
    width: 100%;
    box-sizing: border-box;
}

.modelbox .formbox .row .phonebox {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.modelbox .formbox .row .phonebox .selectnum {
    border-radius: 0.8rem;
    height: 4.8rem;
    padding: 0 1.6rem;
    font-size: 1.1rem;
    display: block;
    width: 10rem;
    position: relative;
    background: url(/images/icon_down_b.png) calc(100% - 1.2rem) center no-repeat #F6F6F6;
    background-size: 2rem 2rem;
}

.modelbox .formbox .row .phonebox .input {
    width: calc(100% - 10.6rem);
}

.modelbox .formbox .rowdiv {
    font-size: 1.75rem;
}

.modelbox .formbox .rowdiv .radio {
    /* font-size: 0.875rem; */
    font-weight: 500;
    line-height: 2.0rem;
    margin-bottom: 0.6rem;
}

/* .modelbox .formbox .rowdiv .rowSep{
    font-size:1.75rem;
} */
.modelbox .formbox .rowdiv .rowSep div {
    margin: 0.6rem 0.5rem;
}

.modelbox .formbox .rowdiv .total {
    /* font-size: 1.25rem; */
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 0.6rem;
}

.modelbox .formbox .rowdiv .rowSep .description {
    margin: 3rem 0.5rem;

}

.modelbox .formbox .rowdiv .rowSep .description span {
    font-weight: 600;
    /* font-size:1.35px; */
}

.modelbox .formbox .rowdivSep {
    width: 100%;
    padding-top: 1.8rem;
    border-top: 1px solid #EAEAEA
}

.modelbox .formbox {
    .wholerow {
        font-size: 14px;
        font-weight: 700;
        justify-content: flex-start;
        align-items: flex-start;

        .err {
            color: #f00;
            font-size: 12px;
        }

        .msg {
            color: #87c4a0;
            font-size: 12px;
            vertical-align: middle;
        }
    }

    .ldiv {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-grow: 1;
        margin-right: 10px;
    }

    .capplied {
        margin-bottom: 8px;
        border: 1px solid #87c4a0;
        padding: 2px 6px;
        border-radius: 0.8rem;
    }

    .childcenter {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
}

.modelbox .navbox {
    margin-top: 2rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow: auto;
}

.modelbox .navbox::-webkit-scrollbar {
    display: none;
}

.modelbox .navbox p {
    background: #FFFFFF;
    border: 1px solid #EAEAEA;
    border-radius: 2.4rem;
    line-height: 3.2rem;
    padding: 0 2rem;
    color: #333;
    font-family: Poppins-Bold;
    font-size: 1.4rem;
    font-weight: 600;
    margin-right: 1.2rem;
    cursor: pointer;
    white-space: nowrap;
}

.modelbox .navbox p.on {
    border: 0;
    background: #4F6F52;
    color: #fff;
}

.hotelbox {
    margin-top: 3.2rem
}

.hotelbox .tit {
    font-family: Poppins-Bold;
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 2.2rem;
}

.hotelbox .listbox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}

.hotelbox .listbox .hotel {
    width: 32%;
    border: 1px solid #EAEAEA;
    border-radius: 1.2rem;
    box-sizing: border-box;
    margin-right: 2%;
    margin-top: 1.2rem;
    overflow: hidden;
}

.hotelbox .listbox .hotel:nth-child(3n) {
    margin-right: 0;
}

.hotelbox .listbox .hotel .pic {
    width: 100%;
    height: 13.8rem;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.hotelbox .listbox .hotel .info {
    padding: 1.2rem 1.6rem;
    box-sizing: border-box;
    font-size: 1.4rem;
    line-height: 2.0rem;
}

.hotelbox .listbox .hotel .info h3 {
    font-family: Poppins-Bold;
    font-weight: 700;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}

.hotelbox .listbox .hotel .info .txt {
    color: #666666;
    margin: 0.6rem 0 0.8rem;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}

.hotelbox .listbox .hotel .info .moretxt {
    font-size: 1.4rem;
    font-weight: 600;
    line-height: 2.2rem;
    color: #1B80DE;
    cursor: pointer;
}

.hotelbox .listbox .hotel .info .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    font-family: Poppins-Bold;
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 2.0rem;
}

.hotelbox .listbox .hotel .info .price {
    color: #FF5722;
}

.hotelbox .listbox .hotel .info .el-select {

    border: 0px solid #4F6F52 !important;

}

.el-select {

    border: 0px solid #4f6f52;

}

/* Mobile */
@media screen and (max-width:750px) {

    .modelbox .formbox {
        display: block;

    }



    .modelbox .formbox .row .input {

        font-size: 1.4rem;

    }

    .modelbox {
        padding: 1.2rem 1.6rem 1.6rem;
        margin-bottom: 1.6rem;
    }

    .modelbox .formbox .row {
        width: 100%;
    }

    .hotelbox {
        margin-top: 2.4rem;
    }

    .hotelbox .listbox {
        display: block;
    }

    .hotelbox .listbox .hotel {
        width: 100%;
        margin-right: 0;
    }

}
</style>

<!-- Popup -->
<style scoped>
.prop .con .close {
    top: 1.6rem;
    right: 1.6rem;
}

.selTravprop .con {
    width: 56.8rem;
    padding: 3.2rem 4rem 4rem;
}

.prop .tittype {
    font-family: Poppins-Bold;
    font-size: 2.3833rem;
    font-weight: 700;
    line-height: 30px;
    text-align: left;
    margin-bottom: 2.4rem;
}

.prop .peoplelist {
    max-height: 75vh;
    overflow: auto;
    margin-bottom: 3.2rem;
}

.prop .peoplelist .el-checkbox {
    display: block;
    background: #F6F6F6;
    padding: 1.6rem;
    border-radius: 0.4rem;
    margin-bottom: 1.2rem;
    height: auto;
    margin-right: 0;
    position: relative;
}

.prop .peoplelist .el-checkbox .ico {
    width: 2.4rem;
    height: 2.4rem;
    position: absolute;
    right: 1.6rem;
    top: calc(50% - 1.2rem)
}

.prop .formbox {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    max-height: 75vh;
    overflow: auto;
}

.prop .formbox .row {
    width: 48%;
    margin-bottom: 2rem;
}

.prop .formbox .row.width {
    width: 100%;
}

.prop .formbox .row .label {
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.0rem;
    margin-bottom: 0.6rem;
    color: #666;
}

.prop .formbox .row .label i {
    color: #F92D2D;
}

.prop .formbox .row .input {
    background: #F6F6F6;
    border-radius: 0.8rem;
    height: 4.8rem;
    padding: 0 1.6rem;
    font-size: 1.6rem;
    display: block;
    width: 100%;
}

.prop .formbox .row .phonebox {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.prop .formbox .row .phonebox .selectnum {
    border-radius: 0.8rem;
    height: 4.8rem;
    padding: 0 1.6rem;
    font-size: 1.6rem;
    display: block;
    width: 10rem;
    position: relative;
    background: url(/images/icon_down_b.png) calc(100% - 1.2rem) center no-repeat #F6F6F6;
    background-size: 2rem 2rem;
}

.prop .formbox .row .phonebox .input {
    width: calc(100% - 10.6rem);
}

.prop .formbox .el-checkbox {
    height: 2.4rem;
    margin-right: 1rem;
}

.prop .formbox .checkbox {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    color: #333;
    font-family: Poppins;
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 2.2rem;
    padding-top: 3rem;
    border-top: 1px solid #EAEAEA;
    margin-bottom: 2.4rem;
}

.prop .formbox .errtxt {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    color: #666;
    font-family: Poppins;
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 1.6rem;
    margin-top: 0.6rem;
}

.prop .formbox .errtxt .ico {
    width: 1.6rem;
    height: 1.6rem;
    margin-right: 0.6rem;
}

.prop .btnbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.prop .btnbox .btn {
    line-height: 4.8rem;
    font-family: Poppins-Bold;
    font-size: 1.6rem;
    font-weight: 700;
    cursor: pointer;
    background: #4F6F52;
    border-radius: 0.8rem;
    width: 25rem;
    color: #fff;
    text-align: center
}

.prop .btnbox .addbtn {
    border: 1px solid #4F6F52;
    color: #4F6F52;
    background: transparent;
    width: 13.6rem;
}

.prop .btnbox .backbtn {
    background: #F6F6F6;
    color: #333;
    width: 8.3rem;
}

.hotelprop .con {
    width: 82.4rem;
    padding: 4.8rem;
}

.hotelprop .infobox {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: row-reverse;
}

.hotelprop .infobox .pic {
    width: 38rem;
    height: 38rem;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 1.2rem;
    overflow: hidden;
    position: relative;
}

.hotelprop .infobox .txtbox {
    width: calc(100% - 38rem - 4.8em);
    min-height: 38rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
}

.hotelprop .infobox .txtbox h3 {
    font-family: DMSerifDisplay;
    font-size: 2.0rem;
    font-weight: 400;
    line-height: 1.4em;
    color: #333;
}

.hotelprop .infobox .txtbox .txt {
    font-family: Poppins;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 1.5em;
    margin-top: 1rem;
    color: #666;
}

.hotelprop .infobox .txtbox .price {
    font-family: Poppins;
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 1.4em;
    color: #FF5722;
    margin-top: 2.4rem;
}

.all {
    overflow: visible !important;
    text-overflow: initial !important;
    -webkit-line-clamp: initial !important;
}


@media screen and (max-width:750px) {

    .prop .con {
        padding-bottom: 8rem !important
    }

    .prop .con.pay-success-con {
        padding: 0 !important;
    }

    .prop .btnbox {
        position: absolute;
        bottom: 0;
        left: 0;
        background: #fff;
        padding: 1.6rem;
        box-sizing: border-box;
        width: 100%
    }

    .prop .btnbox .btn {
        width: 48% !important;
    }

    .hotelprop .infobox {
        display: block;
        max-height: 80vh;
        overflow-y: auto;
    }

    .hotelprop .infobox .pic {
        width: 100%;
        height: calc(100vw - 3.2rem);
        margin-bottom: 2.4rem;
    }

    .hotelprop .infobox .txtbox {
        width: calc(100%);
        min-height: auto;
        display: block;
    }

    .all {
        overflow: visible !important;
        text-overflow: initial !important;
        -webkit-line-clamp: initial !important;
    }
}
</style>
<!-- Checkout/Payment  -->
<style scoped>
.paypal-flex-banner-wrap {
    margin: 1.2rem 0 0.4rem;
    width: 100%;
    min-height: 50px;
    border-radius: 6px;
    overflow: hidden;
}

.titlebox {
    margin-top: 3.2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.titlebox .paytype {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.titlebox .paytype .ico {
    width: 4.2rem;
    display: block;
    margin-left: 0.6rem;
}

.titlebox .paytype .paytype-label {
    display: flex;
    align-items: center;
    min-height: 2.9rem;
    margin-left: 0.6rem;
    padding: 0 0.8rem;
    border-radius: 0.4rem;
    background: #f7f7f7;
    color: #f15b2a;
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
}

.codebox {
    position: relative;
    width: 100%;
    margin: 1.6rem 0;
}

/* The booking summary column, dimmed while a coupon / Groupon apply recalculates the totals. */
.summary-updating-wrap {
    position: relative;
    width: 29%;
}

.summary-updating-wrap > .rightpage {
    width: 100%;
}

.summary-updating > .rightpage {
    opacity: 0.45;
    pointer-events: none;
    transition: opacity 150ms ease-out;
}

.summary-updating__note {
    position: absolute;
    top: 6rem;
    left: 50%;
    z-index: 2;
    transform: translateX(-50%);
    padding: 0.8rem 1.6rem;
    border-radius: 2rem;
    background: #4f6f52;
    color: #fff;
    font-size: 1.4rem;
    white-space: nowrap;
}

button.vchbtn {
    border: 0;
    font-family: inherit;
    line-height: inherit;
}

.vchbtn:disabled {
    opacity: 0.6;
    cursor: wait;
}

@media screen and (max-width: 750px) {
    .summary-updating-wrap {
        width: 100%;
    }
}

.vchbtn {
    cursor: pointer;
    color: rgb(0, 0, 0);
    background: rgb(0, 241, 189);
    border-radius: 0.8rem;
    font-weight: 700;
    text-align: center;
    padding: 1.3rem 1.1rem 1.0rem 1.1rem;
    top: 0px;
    font-size: 1.6rem;
    flex-shrink: 0;
    flex-basis: 25%;
    min-width: 80px;
    max-width: 120px;
    width: 25%;
}

.inabtn {
    pointer-events: none;
    opacity: 0.4;
}

.vchimg {
    width: 19px;
    color: rgb(208, 208, 208);
    height: 19px;
    padding-top: 9px;
    object-fit: cover;
}

.groupon-voucher-layout {
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 1.6rem;
}

.groupon-voucher-main {
    flex: 1;
    min-width: 0;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 2rem;
    row-gap: 1.6rem;
}

.groupon-voucher-side {
    width: 12rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-bottom: 1.6rem;
}

.groupon-voucher-form .groupon-voucher-main .row {
    width: 100%;
    margin-top: 0;
}

.groupon-applied-row {
    width: 100%;
    justify-content: flex-start;
    margin-top: 1.2rem;
    grid-column: 1 / -1;
}

.groupon-voucher-main > .wholerow {
    grid-column: 1 / -1;
}

.groupon-apply-btn {
    width: 100%;
    max-width: 100%;
}

.groupon-applied {
    display: inline-flex;
    width: fit-content;
    max-width: 100%;
    padding: 1rem 1.2rem;
}

.groupon-applied__content {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    width: auto;
    flex-wrap: wrap;
}

.groupon-applied__title {
    font-weight: 700;
    white-space: nowrap;
    padding-top: 0.3rem;
}

.groupon-applied__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 0.8rem;
    flex: 1;
}

.groupon-applied__chip {
    display: inline-flex;
    align-items: center;
    min-height: 3.4rem;
    max-width: 100%;
    padding: 0.6rem 0.8rem 0.6rem 1.2rem;
    border-radius: 999px;
    background: rgba(135, 196, 160, 0.12);
    border: 1px solid #87c4a0;
    color: #4f6f52;
    font-family: Poppins-Bold;
    font-size: 1.3rem;
    line-height: 1.8rem;
}

.groupon-applied__chip-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.groupon-applied__chip-remove {
    margin-left: 0.8rem;
    padding: 0;
    border: 0;
    background: transparent;
    color: #4f6f52;
    font-family: Poppins-Bold;
    font-size: 1.8rem;
    line-height: 1;
    cursor: pointer;
    flex-shrink: 0;
}

.codebox .discountbox {
    position: absolute;
    z-index: 9999;
    border: 1px solid #dddddd;
    width: 100%;
    padding: 10px;
    background-color: #fff;
    opacity: 1;
    border-radius: 0.8rem;
}

.codebox .btn {
    cursor: pointer;
    background: #4F6F52;
    border-radius: 0.8rem;
    width: 8.5rem;
    color: #fff;
    text-align: center;
    line-height: 3.6rem;
    font-family: Poppins-Bold;
    font-size: 1.6rem;
    font-weight: 700;
    position: absolute;
    right: 1.6rem;
    top: calc(50% - 1.8rem);
}

.codebox .input {
    background: #F6F6F6;
    border-radius: 0.8rem;
    height: 4.8rem;
    padding: 0 1.6rem;
    font-size: 1.6rem;
    display: block;
    width: 100%;

}

.Creditbox {
    background: #F6F6F6;
    border-radius: 0.8rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.4rem 0 0.4rem 1.6rem;
}

.Creditbox .iconpic {
    width: 6rem;
    display: block;
}

.modelbox .formbox .row .el-select.input {
    padding: 0;
    border: 0;
    background: #F6F6F6;
    box-shadow: none;
}

.modelbox .formbox .row .el-select.input:hover,
.modelbox .formbox .row .el-select.input:focus-within {
    border: 0;
    box-shadow: none;
}

.modelbox .formbox .row .el-select.input :deep(.el-select__wrapper) {
    min-height: 5.4rem;
    padding: 0 1.6rem;
    border: 0;
    border-radius: 0.8rem;
    background: #F6F6F6;
    box-shadow: none !important;
}

.modelbox .formbox .row .el-select.input :deep(.el-select__wrapper.is-hovering),
.modelbox .formbox .row .el-select.input :deep(.el-select__wrapper.is-focused),
.modelbox .formbox .row .el-select.input :deep(.el-select__wrapper:hover),
.modelbox .formbox .row .el-select.input :deep(.el-select__wrapper:focus-visible) {
    border: 0;
    outline: none;
    box-shadow: none !important;
}

.Creditbox .el-select.input {
    flex: 1;
    background: transparent;
}

.Creditbox .el-select.input :deep(.el-select__wrapper),
.Creditbox .el-select.input :deep(.el-select__wrapper.is-hovering),
.Creditbox .el-select.input :deep(.el-select__wrapper.is-focused),
.Creditbox .el-select.input :deep(.el-select__wrapper:hover),
.Creditbox .el-select.input :deep(.el-select__wrapper:focus-visible) {
    background: transparent;
}

.ttg-coins-panel {
    width: 100%;
    margin-top: 1.2rem;
    padding: 1.8rem 0 0;
    color: #333333;
}

.ttg-coins-title {
    margin-bottom: 1rem;
    font-family: Poppins-Bold;
    font-size: 1.8rem;
    font-weight: 700;
    line-height: 1.4;
}

.ttg-coins-field {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 4.8rem;
    border-radius: 0.8rem;
    background: #f6f6f6;
}

.ttg-coins-input {
    width: 100%;
}

:deep(.ttg-coins-input .el-input__wrapper) {
    min-height: 4.8rem;
    padding: 0 18rem 0 1.6rem;
    border-radius: 0.8rem;
    background: transparent;
    box-shadow: none;
}

:deep(.ttg-coins-input .el-input__inner) {
    color: #333333;
    font-family: Poppins;
    font-size: 1.8rem;
    font-weight: 500;
    text-align: left !important;
}

.ttg-coins-balance {
    position: absolute;
    right: 1.6rem;
    top: 50%;
    transform: translateY(-50%);
    color: #666666;
    font-size: 1.4rem;
    font-weight: 500;
    white-space: nowrap;
    pointer-events: none;
}

.ttg-coins-balance span {
    color: #4ca771;
    font-weight: 700;
}

.ttg-coins-description {
    display: flex;
    align-items: flex-start;
    gap: 1.2rem;
    margin-top: 2.4rem;
    color: #666666;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 1.45;
}

.ttg-coins-info-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 1.6rem;
    width: 1.6rem;
    height: 1.6rem;
    margin-top: 0.2rem;
    border: 1px solid #6f7770;
    border-radius: 50%;
    color: #6f7770;
    font-size: 1.1rem;
    font-weight: 700;
    line-height: 1;
}

.ttg-coins-divider {
    width: 100%;
    height: 1px;
    margin-top: 2.8rem;
    background: #d9d9d9;
}

.ttg-coins-remaining {
    margin-top: 1.8rem;
    color: #333333;
    font-family: Poppins-Bold;
    font-size: 1.8rem;
    font-weight: 700;
    line-height: 1.4;
}

.ttg-coins-remaining span {
    color: #4ca771;
}

.radiobox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #CCCCCC;
    padding: 0.8rem 1.6rem;
    border-radius: 0.8rem;
    cursor: pointer;
}

.radiobox .price {
    font-family: Poppins-Bold;
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 2.0rem;
    color: #000;
}

.radiobox .txt {
    font-family: Poppins;
    font-size: 1.3rem;
    font-weight: 400;
    line-height: 1.6rem;
    margin-top: 0.3rem;
    color: #000;
}

.radiobox.on {
    border: 1px solid #00F1BD;
    background: #00F1BD;
}

.radiobox.on .txt {
    color: #000;
}

.signature .namebox {
    border-radius: 0.8rem;
    background: url(/images/flight/bg.png) center no-repeat;
    background-size: 100% 100%;
    height: 12.8rem;
    margin: 1.6rem 0 2.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.signature .namebox .clear {
    background: #CCCCCC;
    font-family: Poppins-Bold;
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 2.8rem;
    color: #fff;
    padding: 0 1.6rem;
    border-radius: 0.6rem;
    position: absolute;
    right: 1.2rem;
    bottom: 1.2rem;
    cursor: pointer;
}

.signature .namebox .pic {
    display: block;
    max-width: 100%;
    max-height: 100%;
}

.signature .tit {
    font-family: Poppins-Bold;
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 2.2rem;
    text-align: left;
    color: #333
}

.signature .txt {
    font-family: Poppins;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.2rem;
    text-align: left;
    color: #333;
    margin: 0.6rem 0;
}

.signature .el-radio-group {
    margin: 1.6rem 0;
    font-family: Poppins;
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 2.2rem;
    text-align: left;
    color: #333;
    display: flex;
    justify-content: flex-start;
    align-items: center
}

.signature .el-radio {
    margin-right: 4.8rem
}

.signature .btn {
    cursor: pointer;
    background: #4F6F52;
    border-radius: 0.8rem;
    width: 25.5rem;
    color: #fff;
    text-align: center;
    line-height: 4.6rem;
    font-family: Poppins-Bold;
    font-size: 1.4rem;
    font-weight: 700;
}

.acceptbox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #333333;
    font-family: Poppins;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.0rem;
    margin: 0.5rem 0;
}

/* .termFlightdiv .acceptbox{
    margin:2.2rem 0 0.5rem 0;
} */
:deep(.acceptbox .el-checkbox__input) {
    border: 1px solid #aaa !important;
}

.acceptbox a {
    color: #4F6F52;
    display: inline;
    text-decoration: underline;
}

.smscode .txt {
    font-size: 14px;
    font-weight: 700;
}

.redborder {
    border: 1px solid #ff5722 !important;
}

:deep(.el-checkbox__label),
:deep(.el-radio__label) {

    font-size: 1.3rem !important;
}

/* ipad  */
@media screen (min-width:750px) and (max-width: 1080px) {


    .signature .btn {
        font-size: 1.3rem !important;
    }


    .el-checkbox {
        --el-checkbox-font-size: 1.2rem;
    }
}

/* Mobile */
@media screen and (max-width:750px) {
    .acceptbox {

        margin: 1.5rem 0;
    }

    .codebox .input {
        width: 100% !important;
    }

    .titlebox {
        display: block;
    }

    .titlebox .paytype {
        justify-content: flex-start;
        margin-top: 1.2rem;
    }

    .ttg-coins-panel {
        padding-top: 1.4rem;
    }

    .ttg-coins-title {
        font-size: 1.6rem;
    }

    .ttg-coins-field {
        align-items: center;
        min-height: 4.8rem;
    }

    :deep(.ttg-coins-input .el-input__wrapper) {
        padding: 0 20.5rem 0 1.2rem;
    }

    :deep(.ttg-coins-input .el-input__inner) {
        font-size: 1.6rem;
    }

    .ttg-coins-balance {
        position: absolute;
        right: 1.2rem;
        top: 50%;
        transform: translateY(-50%);
        padding: 0;
        font-size: clamp(1.1rem, 3vw, 1.3rem);
        line-height: 1;
        white-space: nowrap;
    }

    .ttg-coins-description {
        margin-top: 1.8rem;
        font-size: 1.4rem;
    }

    .ttg-coins-divider {
        margin-top: 2.2rem;
    }

    .ttg-coins-remaining {
        font-size: 1.6rem;
    }

    .smscode .txt {
        font-size: 14px;
        font-weight: 700;
    }

    .redborder {
        border: 1px solid #ff5722 !important;
    }

    .childcenter {
        flex-direction: row;
        /* Force items to stay on one line */
    }

    .wholerow {
        align-items: center;
    }

    .ldiv {
        flex-grow: 1;
        /* Let the input take the remaining space */
        width: 70%;
    }

    .btn {
        flex-basis: 25%;
        /* Use 30% button width on smaller screens */
    }

    .codebox {
        margin: 0px;
    }

    .vchimg {
        float: right;
        width: 19px;
        color: rgb(208, 208, 208);
        height: 19px;
        padding-top: 7px;
        object-fit: cover;
    }

    .groupon-voucher-layout {
        display: block;
    }

    .groupon-voucher-main {
        display: block;
    }

    .groupon-voucher-side {
        width: 100%;
        padding-bottom: 0;
        margin-top: 1.2rem;
    }

    .groupon-apply-btn {
        width: 100%;
        max-width: none;
    }

    .groupon-applied__content {
        gap: 0.8rem;
    }

    .groupon-applied {
        width: fit-content;
        max-width: 100%;
    }

    .groupon-applied__title {
        width: 100%;
        padding-top: 0;
    }

    .groupon-applied__chips {
        width: 100%;
    }
}

/* Keep the payment-success design independent from legacy global .customer_popwin rem rules. */
.prop .con.pay-success-con .customer_popwin {
    height: 100%;
    padding: 50px 10px;
    gap: 24px;
}

.prop .con.pay-success-con .customer_popwin .win_img {
    margin: 0 !important;
}

.prop .con.pay-success-con .customer_popwin .win_img img {
    width: 89px !important;
    height: 89px !important;
}

.prop .con.pay-success-con .customer_popwin .win_title {
    margin: 0 !important;
    font-size: 32px;
}

.prop .con.pay-success-con .customer_popwin .win_con {
    padding: 0 !important;
    font-size: 16px;
}

.prop .con.pay-success-con .customer_popwin .button {
    flex: 0 0 auto;
    width: 100% !important;
    height: 56px;
    min-height: 56px;
    padding: 16px 32px;
    margin: 0;
    font-size: 16px;
}

.prop .con.pay-success-con .customer_popwin .pay-success-actions {
    display: flex;
    flex-direction: column !important;
    align-items: stretch;
    width: 100%;
    max-width: 357px;
    gap: 12px;
}

@media screen and (max-width: 750px) {
    .prop .con.pay-success-con .customer_popwin {
        padding: 32px 20px;
        gap: 12px;
    }

    .prop .con.pay-success-con .customer_popwin .win_img {
        margin: 0 0 8px !important;
    }

    .prop .con.pay-success-con .customer_popwin .win_title {
        font-size: 22px;
    }

    .prop .con.pay-success-con .customer_popwin .win_con {
        font-size: 12px;
    }

    .prop .con.pay-success-con .customer_popwin .button {
        height: 42px;
        min-height: 42px;
        padding: 12px 24px;
        font-size: 12px;
    }

    .prop .con.pay-success-con .customer_popwin .pay-success-actions {
        flex-direction: column !important;
        align-items: stretch;
        max-width: none;
        gap: 12px;
        margin-top: 8px !important;
    }
}
</style>

<style scoped>
/* Mobile: let long welcome/reward point labels wrap instead of running under the Apply button. */
@media screen and (max-width: 750px) {
    .checkbox-row :deep(.el-checkbox) {
        height: auto;
        align-items: flex-start;
        white-space: normal;
    }
    .checkbox-row :deep(.el-checkbox__label) {
        white-space: normal;
        word-break: break-word;
        line-height: 2rem;
        font-size: 1.4rem;
    }
    .checkbox-row :deep(.el-checkbox__input) {
        margin-top: 0.3rem;
    }

    /* Section titles (Payment Amount, Payment Method, Billing address) on the V2 20px step. */
    .title {
        font-size: 2rem;
        line-height: 2.6rem;
    }

    /* Option labels ("Full Amount", "Deposit Amount", verification code) on the 14px step. */
    .radiobox .txt {
        font-size: 1.4rem;
    }

    /* Card form labels (Card Type, Country, State/Province) on the 14px step. */
    .row > .label {
        font-size: 1.4rem;
    }
}
</style>
